import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const ja: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "引用スタイル一覧が見つかりません",
    metaTitle: "{label} で始まる引用スタイル",
    metaDescription:
      "{label} で始まる {count} 件の Citation Style Language スタイルを一覧できます。任意のスタイルを開くと、実際の引用例と無料ジェネレーターが利用できます。",
    ogSubtitle: "専用の例とジェネレーターを備えた {count} 件のスタイル。",
    ogKind: "A–Z 一覧",
    schemaName: "{label} で始まる引用スタイル",
    schemaDescription:
      "{label} で始まる {count} 件の Citation Style Language スタイルのアルファベット順一覧。",
    breadcrumbStyles: "引用スタイル",
    heading: "{label} で始まる引用スタイル",
    intro:
      "CSL カタログのこの部分にある {count} 件のスタイルをすべて閲覧できます。各ページにはそのスタイル固有の書式付き例と無料の引用ジェネレーターがあります。",
    navLabel: "引用スタイル A〜Z",
    listHeading: "{label} で始まるすべてのスタイル",
  },
  nav: {
    tools: "ツール",
    guides: "ガイド",
    styles: "すべてのスタイル",
    bibliography: "マイ文献リスト",
    search: "検索",
    glossary: "用語集",
    home: "ホーム",
    menu: "メニュー",
  },

  home: {
    title: "無料の引用文献ジェネレーター",
    subtitle: "2026年版",
    intro:
      "DOI・URL・BibTeX を貼り付けるか、書籍を検索するだけで、APA、MLA、シカゴ、バンクーバー、ハーバードほか数千のスタイルに沿った参考文献を正しい書式で作成します。完全無料、有料プラン不要、登録不要。",
    browseAllStyles: "{count} 件すべての引用スタイルを見る →",
    featuresHeading: "引用に必要なものがすべて揃っています",
    featureStyles: "{count} スタイル",
    featureStylesDetail: "APA、MLA、シカゴほか",
    featureBibliographies: "複数の文献リスト",
    featureBibliographiesDetail: "課題ごとに整理",
    featureBookSearch: "書籍検索",
    featureBookSearchDetail: "書名や著者名から",
    featureExport: "どこへでも書き出し",
    featureExportDetail: "BibTeX、Word、RIS、CSV",
    featureDarkMode: "ダークモード",
    featureDarkModeDetail: "目にやさしい表示",
    featureNoSignup: "登録不要",
    featureNoSignupDetail: "ずっと無料、有料プラン不要",
    aboutHeading: "学生と研究者のための無料引用文献ジェネレーター",
    aboutBody:
      "CitationEasy は 10,000 を超える学術引用スタイルに対応しています。心理学の APA、文学の MLA、歴史学のシカゴ、医学雑誌のバンクーバーなど、書式はそのスタイル自身の公式定義に基づいており、近似ではありません。",
    howItWorksHeading: "使い方",
    howItWorksStep1:
      "DOI、URL、ISBN、PubMed ID、arXiv ID、または BibTeX を貼り付けます。書名から書籍を検索することもできます。",
    howItWorksStep2:
      "引用スタイルを選びます。入力すると {count} 件すべてから検索できます。",
    howItWorksStep3:
      "できあがった参考文献をコピーするか、文献リストに保存して Word・BibTeX・RIS に書き出します。",
    privacyNote:
      "文献リストはご自身のブラウザーに保存されます。アカウントは不要で、サーバーへ送信されるものはありません。",
  },

  hubs: {
    toolsTitle: "無料のライティング・引用ツール",
    toolsIntro:
      "ブラウザーで動く {count} 種類のツール。あらゆる資料タイプに対応した引用ジェネレーター、文字数・単語数カウンター、読みやすさ判定、書式整形、各種変換ツールを揃えています。すべて無料ですぐに使えます。",
    stylesTitle: "すべての引用スタイルを見る",
    stylesIntro:
      "Citation Style Language プロジェクトの {count} スタイルすべて。国・分野・学問領域で検索し、絞り込めます。",
    guidesTitle: "引用と学術ライティングのガイド",
    guidesIntro:
      "資料の種類ごとの引用方法、見つけた資料の評価の仕方、より良い書き方についての詳しいガイド。",
    howToCiteTitle: "あらゆる資料の引用方法",
    howToCiteIntro:
      "よく使う資料タイプと主要な引用スタイルを組み合わせた手順ページ。それぞれに実際の作例が付いています。",
    faqTitle: "引用に関するよくある質問",
    faqIntro: "引用のときに学生が実際に迷う点への、短く正確な回答。",
    glossaryTitle: "引用の用語集",
    glossaryIntro:
      "スタイルガイドや課題の指示に出てくる用語を、平易なことばで解説します。",
    openHub: "開く",
  },

  styleLanding: {
    metaTitle: "無料の{style}引用ジェネレーター",
    metaDescription:
      "{style} の引用を無料で作成。DOI・URL・ISBN・BibTeX を貼り付けるだけで、正しい {style} 書式の参考文献と文中引用が得られます。",
    heading: "{style} 引用ジェネレーター",
    intro:
      "書籍・学術論文・ウェブサイトの正確な {style} 引用をワンクリックで作成します。無料・登録不要。",
    aboutHeading: "{style} について",
    whenToUseHeading: "{style} を使う場面",
    factsHeading: "{style} の概要",
    factEdition: "版",
    factSystem: "引用方式",
    factInText: "文中での形式",
    factReferenceList: "一覧の名称",
    factFields: "主な分野",
    systemAuthorDate: "著者・年方式",
    systemNumbered: "番号方式",
    systemFootnotes: "脚注方式",
    howToHeading: "この {style} ジェネレーターの使い方",
    howToStep1:
      "上の入力欄に URL、DOI、ISBN、BibTeX を貼り付けるか、書名で書籍を検索します。",
    howToStep2:
      "このページでは {style} がすでに選択されているので、そのまま作成できます。",
    howToStep3:
      "結果を文書に貼り付けるか、保存しておいて後で一覧をまとめて書き出します。",
    relatedHeading: "{style} に関するその他の情報",
    englishOnlyNote:
      "{style} の詳しいガイドや資料タイプ別の用例は英語でご覧いただけます。",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "引用スタイルが見つかりません",
    metaTitle: "{style}引用ジェネレーター－無料の{style}書式",
    metaFormatAndFields: "{style}は{fields}で使われる{format}スタイルです。",
    metaFormatOnly: "{style}は{format}スタイルです。",
    metaFieldsOnly: "{style}は{fields}で使われています。",
    metaPromiseNote:
      "{style}の実際の脚注例を確認し、無料で自分の引用を作成できます。",
    metaPromiseExamples:
      "{style}による論文・書籍・ウェブサイトの実際の引用例を確認し、無料で自分の引用を作成できます。",
    ogKindFormat: "{format} スタイル",
    ogKindDefault: "引用スタイル",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "と",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "{name} の引用スタイルです。Citation Style Language リポジトリに由来します。",
    genericWhenUsed:
      "{name} スタイルを採用する出版物への投稿時、またはその引用時に使用します。",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "人類学",
    disciplineAstronomy: "天文学",
    disciplineBiology: "生物学",
    disciplineBotany: "植物学",
    disciplineChemistry: "化学",
    disciplineCommunications: "コミュニケーション学",
    disciplineEngineering: "工学",
    disciplineGenericBase: "一般",
    disciplineGeography: "地理学",
    disciplineGeology: "地質学",
    disciplineHistory: "歴史学",
    disciplineHumanities: "人文学",
    disciplineLaw: "法学",
    disciplineLinguistics: "言語学",
    disciplineLiterature: "文学",
    disciplineMath: "数学",
    disciplineMedicine: "医学",
    disciplinePhilosophy: "哲学",
    disciplinePhysics: "物理学",
    disciplinePoliticalScience: "政治学",
    disciplinePsychology: "心理学",
    disciplineScience: "科学",
    disciplineSocialScience: "社会科学",
    disciplineSociology: "社会学",
    disciplineTheology: "神学",
    disciplineZoology: "動物学",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "文中引用に著者名と発行年を示し、文献リストを著者名のアルファベット順に並べる、著者・年方式のスタイル",
    formatClassNumeric:
      "出典を本文中で最初に引用された順に番号付けし、文中引用にもその番号を用いる、番号方式のスタイル",
    formatClassNote:
      "引用を本文中の丸括弧ではなく脚注または注釈に記載する、脚注方式のスタイル",
    formatClassLabel:
      "著者名と発行年から作る簡潔なラベルを文中引用に用いる、ラベル方式のスタイル",
    formatClassAuthor:
      "文中引用には著者名のみを示し、詳細は文献リストに記載する、著者方式のスタイル",
    formatClassOther: "{format}方式のスタイル",
    breadcrumbStyles: "引用スタイル",
    internationalLabel: "国際的",
    heading: "{style} 引用ジェネレーター",
    intro:
      "書籍・論文・ウェブサイトの正確な {style} 引用をワンクリックで作成します。",
    examplesHeading: "{style} の引用例",
    examplesIntro: "同じ3つの資料を {style} で整形した例：",
    examplesIntroWithFormat:
      "同じ3つの資料を {style}（{format}）で整形した例：",
    examplesNoteOnlyIntro:
      "{style} は脚注方式のスタイルです。文献リストを持たず、すべての引用は脚注として示されます。以下はサンプルの論文を {style} で引用した例です：",
    labelJournalArticle: "学術論文",
    labelBook: "書籍",
    labelWebsite: "ウェブサイト",
    labelFootnote: "脚注（学術論文）",
    labelInText: "文中引用（学術論文の場合）",
    aboutHeading: "{style} について",
    whenToUseLabel: "{style} を使う場面：",
    commonInLabel: "よく使われる地域：",
    subjectAreasLabel: "対象分野：",
    formattingRulesLabel: "書式のルール：",
    parentStylePrefix: "{style} は、基となる親スタイルである",
    parentStyleSuffix: "の書式にならっています。",
    howToHeading: "この {style} ジェネレーターの使い方",
    howToBody:
      "上の入力欄に DOI、ニュース記事やウェブページの URL、または BibTeX をそのまま貼り付けてください。書名や著者名で書籍を検索し、ISBN から引用することもできます。スタイルの選択欄で「{style}」を選び（このページではあらかじめ選択されています）、「引用を作成」をクリックします。結果を文献リストにコピーしてください。コピーする前に、生成された項目を編集する（例えばタイトルを修正したり日付を追加したりする）こともできます。",
    faqHeading: "{style} に関するよくある質問",
    faqWhatIsQ: "{style} とは何ですか？",
    faqWhenQ: "{style} はいつ使うべきですか？",
    faqInTextQ: "{style} の文中引用はどのような形式ですか？",
    faqInTextA:
      "{style} は{format}です。サンプルの学術論文を本文中で引用すると次のようになります：{example}",
    faqReferenceQ: "{style} の文献リストの記載はどのような形式ですか？",
    faqReferenceA: "{style} で整形した学術論文の例は次のとおりです：{example}",
    faqWhereQ: "{style} は主にどこで使われていますか？",
    faqWhereA: "{style} は{region}で使用されています。{whenUsed}",
    faqRegionDefault: "世界各国",
    faqGenerateQ: "{style} の引用文献を作成するにはどうすればよいですか？",
    faqGenerateA:
      "このページの無料ジェネレーターをご利用ください。DOI、URL（ニュース記事など）、または BibTeX を貼り付けるか、書名や著者名で書籍を検索します。引用スタイルとして {style} を選択し、「引用を作成」をクリックすると、論文や文献リストにそのままコピーできる整形済みの参考文献が得られます。",
    footerSupports:
      "は世界中の数多くの引用スタイルに対応しています。このジェネレーターは Citation Style Language（CSL）の定義を使用しています。参照：",
    footerRepoLink: "公式 CSL リポジトリ",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "この引用を作成する",
    generateBody:
      "URL、DOI、ISBN、または出典情報を貼り付けると、{source}の{style}形式の引用がすぐに完成します。",
    generateCta: "{tool}を開く →",
    guideHeading: "さらに詳しく",
    guideCta: "完全ガイドを読む：{guide}",
    howToCiteHeading: "各スタイルでの{source}の引用方法",
    howToCiteBody: "よく求められるスタイルの書式ルール、テンプレート、具体例。",
    howToCiteMore: "すべての出典タイプとスタイル →",
    citeNowHeading: "{source}を{style}で今すぐ引用する",
    citeNowHowTo: "書式ルールと具体例",
    citeNowTool: "{tool}で作成する",
    citeNowHub: "{style}引用ジェネレーター",
    hubSourcesHeading: "{style}での主な出典の引用方法",
    hubGuidesHeading: "{style}ガイド",
    hubCompareHeading: "{style}と他のスタイルを比較する",
    moreInCollection: "{collection}のその他のツール",
    seeAllInCollection: "{collection}をすべて見る",
  },

  howToCitePage: {
    notFoundTitle: "ページが見つかりません",
    title: "{style}（{edition}）での{source}の引用方法",
    metaTitle: "{style}（{edition}）での{source}の引用方法－2026年更新",
    metaDescription:
      "{description}を{style}形式（{edition}）で引用する方法を解説します。無料の引用例・テンプレート・文中引用ガイド付き。",
    keywordCite: "{source} {style} 引用",
    keywordCitation: "{style} {source} 引用",
    keywordHowTo: "{source} 引用方法",
    keywordExample: "{style} 引用例",
    keywordReference: "{source} 参考文献 {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "引用文献一覧",
    refListWorksCitedPage: "引用文献一覧ページ",
    refListBibliography: "文献目録",
    refListBibliographyLower: "文献目録",
    refListReferenceList: "参考文献リスト",
    refListReferenceListLower: "参考文献リスト",
    backLink: "← すべての引用ガイド",
    lead: "{description}を{style}形式（{edition}）で引用する方法を説明します。このガイドには、文献リストの書式、文中引用の例、主要な書式ルールを掲載しています。",
    referenceFormatHeading: "{style} の {list} 書式",
    referenceFormatIntro:
      "{source}を{list}に記載する際の、標準的な{style}書式は次のとおりです：",
    noTemplateNote:
      "この資料タイプについては、標準的な{style}のテンプレートに従ってください。",
    workedHeading: "{source}の {style} 引用例",
    workedIntro:
      "{source}の完全な{style}参考文献を、公式の{style} CSLスタイル定義で整形した例です（このサイトのジェネレーターと同じ仕組みです）：",
    workedNoteOnlyIntro:
      "{style} では{source}を{list}に記載せず、注のみで引用します。公式の{style} CSLスタイル定義で整形したその注は次のとおりです：",
    workedOscolaNote:
      "このサイトが生成するOSCOLAの出力は第4版のCSLスタイルに従っている。Citation Style Languageのリポジトリには第5版のCSLスタイルがまだ公開されていないためである。手作業で調整すること: 'ibid'はすべて短縮名と(n X)に置き換え、第5版の裁判所識別子を使い、法令の短縮形を一重引用符で囲み、アクセス日よりも恒久リンクまたはDOIを優先する",
    workedCheckedIntro:
      "{source}の完全な{style}参考文献を手作業で作成し、この資料に関する{style}の公式ガイダンスと照合した例です：",
    workedCheckedNoteOnlyIntro:
      "{style} では{source}を{list}に記載せず、注のみで引用します。手作業で作成し、{style}の公式ガイダンスと照合したその注は次のとおりです：",
    workedInTextLabel: "対応する文中引用：",
    inTextHeading: "{style} の文中引用",
    inTextIntro:
      "論文内でこの資料を参照する際は、次のいずれかの形式を使用してください：",
    inTextParenthetical: "括弧内引用",
    inTextNarrative: "文中引用",
    rulesHeading: "{style} の主要な書式ルール",
    stepsHeading: "手順ガイド",
    step1Label: "資料情報を集める：",
    step1Body:
      "{source}を引用するために、著者名、タイトル、発行日、URL または DOI を集めます。",
    step2Label: "参考文献を整形する：",
    step2Body: "上記の{style}（{edition}）テンプレートに従って要素を並べます。",
    step3Label: "文中引用を作成する：",
    step3Body: "この資料を参照する箇所に、括弧内引用または文中引用を加えます。",
    step4Label: "{list}に追加する：",
    step4Body: "論文の末尾に、整形済みの完全な引用を記載します。",
    step5Label: "書式を再確認する：",
    step5Body:
      "斜体、句読点、大文字・小文字の使い方、ぶら下げインデントが{style}の要件に合っているか確認します。",
    ctaHeading: "この引用を自動作成",
    ctaBody:
      "手作業での書式設定は不要です。DOI、URL、ISBN を CitationEasy に貼り付けるだけで、数秒で正確な{style}引用が得られます。",
    ctaButton: "今すぐ{style}で引用する →",
    otherStylesHeading: "{source}を他のスタイルで引用する",
    comboLink: "{style}の{source}",
    otherSourcesHeading: "{style}で他の資料を引用する",
    resourcesHeading: "その他のリソース",
    resourceGenerator: "無料引用ジェネレーター（{count} スタイル）",
    resourceTools: "無料のライティングツール",
    resourceCompare: "引用スタイルを比較",
    resourceGuides: "すべての引用ガイド",
    resourceCheatSheets: "チートシート（APA、MLA、シカゴ）",
    resourceGlossary: "引用用語集（et al.、ibid.、DOI、ぶら下げインデント）",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "資料情報を集める",
    schemaStep1Text:
      "{source}を引用するために必要な情報（著者名、タイトル、日付、URL または DOI など）をすべて集めます。",
    schemaStep2Name: "{style}で整形する",
    schemaStep2Text:
      "{style}（{edition}）の書式ルールに従って、引用の各要素を正しい順序で並べます。",
    schemaStep3Name: "文中引用を作成する",
    schemaStep3Text: "{style}の書式で、対応する文中引用を論文に加えます。",
    schemaStep4Name: "文献リストに追加する",
    schemaStep4Text: "論文の末尾にある{list}に、完全な引用を記載します。",
    faqHowQ: "{style}で{source}を引用するにはどうすればよいですか？",
    faqHowA:
      "{style}（{edition}）で{source}を引用するには、著者名、タイトル、日付、資料の所在情報を記載します。自動で書式を整えるには、無料の引用ジェネレーターをご利用ください。",
    faqFormatQ: "{source}の引用における{style}の書式はどのようなものですか？",
    faqFormatA: "{source}の{style}書式は次のとおりです：{example}",
    faqFormatFallback:
      "{style}の書式では、著者名、タイトル、日付、資料の所在情報などの要素を、決められた順序で並べる必要があります。",
    faqInTextQ: "{style}における{source}の文中引用はどのような形式ですか？",
    faqInTextA:
      "{style}では、上記の例の文中引用は次のようになります：{example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Japanese: no articles or case, so Name, Title, Phrase and Noun are the same plain noun phrase (Reddit and X shorten it in Phrase and Noun); every template attaches a postposition (の, を, で) or the invariant head "{source}を引用するために".
  howToCiteSources: {
    websiteName: "ウェブサイト",
    websiteTitle: "ウェブサイト",
    websitePhrase: "ウェブサイト",
    websiteNoun: "ウェブサイト",
    websiteDescription: "ウェブページ、オンライン記事、ウェブコンテンツ",

    bookName: "書籍",
    bookTitle: "書籍",
    bookPhrase: "書籍",
    bookNoun: "書籍",
    bookDescription: "紙の書籍と電子書籍",

    journalArticleName: "学術論文",
    journalArticleTitle: "学術論文",
    journalArticlePhrase: "学術論文",
    journalArticleNoun: "学術論文",
    journalArticleDescription: "査読付き論文などの学術雑誌掲載論文",

    youtubeVideoName: "YouTube動画",
    youtubeVideoTitle: "YouTube動画",
    youtubeVideoPhrase: "YouTube動画",
    youtubeVideoNoun: "YouTube動画",
    youtubeVideoDescription: "YouTubeなどのオンライン動画",

    podcastName: "ポッドキャスト",
    podcastTitle: "ポッドキャスト",
    podcastPhrase: "ポッドキャスト",
    podcastNoun: "ポッドキャスト",
    podcastDescription: "ポッドキャストのエピソードとシリーズ",

    newspaperArticleName: "新聞記事",
    newspaperArticleTitle: "新聞記事",
    newspaperArticlePhrase: "新聞記事",
    newspaperArticleNoun: "新聞記事",
    newspaperArticleDescription: "紙面およびオンラインの新聞記事",

    magazineArticleName: "雑誌記事",
    magazineArticleTitle: "雑誌記事",
    magazineArticlePhrase: "雑誌記事",
    magazineArticleNoun: "雑誌記事",
    magazineArticleDescription: "紙面およびオンラインの雑誌記事",

    blogPostName: "ブログ記事",
    blogPostTitle: "ブログ記事",
    blogPostPhrase: "ブログ記事",
    blogPostNoun: "ブログ記事",
    blogPostDescription: "ブログ記事やオンラインのオピニオン記事",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedia",
    wikipediaPhrase: "Wikipedia",
    wikipediaNoun: "Wikipedia",
    wikipediaDescription: "Wikipediaの記事とウィキの項目",

    pdfName: "PDF文書",
    pdfTitle: "PDF文書",
    pdfPhrase: "PDF文書",
    pdfNoun: "PDF文書",
    pdfDescription: "PDF文書とレポート",

    interviewName: "インタビュー",
    interviewTitle: "インタビュー",
    interviewPhrase: "インタビュー",
    interviewNoun: "インタビュー",
    interviewDescription:
      "個人的なインタビュー、公開されたインタビュー、放送されたインタビュー",

    socialMediaName: "ソーシャルメディアの投稿",
    socialMediaTitle: "ソーシャルメディアの投稿",
    socialMediaPhrase: "ソーシャルメディアの投稿",
    socialMediaNoun: "ソーシャルメディアの投稿",
    socialMediaDescription: "ツイート、Instagram・Facebookの投稿、TikTok動画",

    governmentDocumentName: "政府文書",
    governmentDocumentTitle: "政府文書",
    governmentDocumentPhrase: "政府文書",
    governmentDocumentNoun: "政府文書",
    governmentDocumentDescription: "政府報告書、法令、公文書",

    dissertationName: "学位論文",
    dissertationTitle: "学位論文",
    dissertationPhrase: "学位論文",
    dissertationNoun: "学位論文",
    dissertationDescription: "博士論文と修士論文",

    conferencePaperName: "会議論文",
    conferencePaperTitle: "会議論文",
    conferencePaperPhrase: "会議論文",
    conferencePaperNoun: "会議論文",
    conferencePaperDescription: "会議録と学会発表",

    lectureNotesName: "講義またはPowerPoint",
    lectureNotesTitle: "講義またはPowerPoint",
    lectureNotesPhrase: "講義またはPowerPoint",
    lectureNotesNoun: "講義またはPowerPoint",
    lectureNotesDescription: "授業の講義、スライド、講座資料",

    webinarName: "ウェビナー",
    webinarTitle: "ウェビナー",
    webinarPhrase: "ウェビナー",
    webinarNoun: "ウェビナー",
    webinarDescription:
      "ライブ配信および録画のオンラインウェビナー・ウェブセミナー",

    onlineCourseName: "オンライン講座",
    onlineCourseTitle: "オンライン講座",
    onlineCoursePhrase: "オンライン講座",
    onlineCourseNoun: "オンライン講座",
    onlineCourseDescription:
      "オンライン講座とMOOC（Coursera、edX、Udemy、FutureLearn）",

    presentationSlidesName: "PowerPointプレゼンテーション",
    presentationSlidesTitle: "PowerPointプレゼンテーション",
    presentationSlidesPhrase: "PowerPointプレゼンテーション",
    presentationSlidesNoun: "PowerPointプレゼンテーション",
    presentationSlidesDescription:
      "PowerPointなどのプレゼンテーション用スライド",

    imageName: "画像または写真",
    imageTitle: "画像または写真",
    imagePhrase: "画像または写真",
    imageNoun: "画像または写真",
    imageDescription: "写真、美術作品、図表、オンライン画像",

    movieName: "映画",
    movieTitle: "映画",
    moviePhrase: "映画",
    movieNoun: "映画",
    movieDescription: "映画作品",

    documentaryName: "ドキュメンタリー",
    documentaryTitle: "ドキュメンタリー",
    documentaryPhrase: "ドキュメンタリー",
    documentaryNoun: "ドキュメンタリー",
    documentaryDescription: "ドキュメンタリー映画とノンフィクション映画",

    tvShowName: "テレビ番組",
    tvShowTitle: "テレビ番組",
    tvShowPhrase: "テレビ番組",
    tvShowNoun: "テレビ番組",
    tvShowDescription: "テレビ番組またはシリーズ",

    songName: "楽曲または音楽",
    songTitle: "楽曲または音楽",
    songPhrase: "楽曲または音楽",
    songNoun: "楽曲または音楽",
    songDescription: "楽曲や音楽の録音",

    poemName: "詩",
    poemTitle: "詩",
    poemPhrase: "詩",
    poemNoun: "詩",
    poemDescription: "アンソロジーや詩集に収録された詩・韻文",

    courtCaseName: "裁判例",
    courtCaseTitle: "裁判例",
    courtCasePhrase: "裁判例",
    courtCaseNoun: "裁判例",
    courtCaseDescription: "裁判例または法的判断",

    patentName: "特許",
    patentTitle: "特許",
    patentPhrase: "特許",
    patentNoun: "特許",
    patentDescription: "特許または知的財産の出願",

    encyclopediaName: "百科事典の項目",
    encyclopediaTitle: "百科事典の項目",
    encyclopediaPhrase: "百科事典の項目",
    encyclopediaNoun: "百科事典の項目",
    encyclopediaDescription: "百科事典の記事または項目",

    dictionaryName: "辞書の項目",
    dictionaryTitle: "辞書の項目",
    dictionaryPhrase: "辞書の項目",
    dictionaryNoun: "辞書の項目",
    dictionaryDescription: "辞書の定義または項目",

    datasetName: "データセット",
    datasetTitle: "データセット",
    datasetPhrase: "データセット",
    datasetNoun: "データセット",
    datasetDescription: "データセットまたはデータベース",

    softwareName: "ソフトウェアまたはアプリ",
    softwareTitle: "ソフトウェアまたはアプリ",
    softwarePhrase: "ソフトウェアまたはアプリ",
    softwareNoun: "ソフトウェアまたはアプリ",
    softwareDescription: "ソフトウェア、アプリ、コンピュータプログラム",

    videoGameName: "ビデオゲーム",
    videoGameTitle: "ビデオゲーム",
    videoGamePhrase: "ビデオゲーム",
    videoGameNoun: "ビデオゲーム",
    videoGameDescription: "ビデオゲームとインタラクティブなゲームソフトウェア",

    pressReleaseName: "プレスリリース",
    pressReleaseTitle: "プレスリリース",
    pressReleasePhrase: "プレスリリース",
    pressReleaseNoun: "プレスリリース",
    pressReleaseDescription: "プレスリリースまたはニュースリリース",

    reportName: "報告書",
    reportTitle: "報告書",
    reportPhrase: "報告書",
    reportNoun: "報告書",
    reportDescription: "報告書またはホワイトペーパー",

    preprintName: "プレプリント",
    preprintTitle: "プレプリント",
    preprintPhrase: "プレプリント",
    preprintNoun: "プレプリント",
    preprintDescription: "arXiv、bioRxivなどのプレプリントサーバーの論文",

    bookChapterName: "書籍の章",
    bookChapterTitle: "書籍の章",
    bookChapterPhrase: "書籍の章",
    bookChapterNoun: "書籍の章",
    bookChapterDescription: "編著書の章とエッセイ",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPTなどの生成AIツール",

    bibleName: "聖書",
    bibleTitle: "聖書",
    biblePhrase: "聖書",
    bibleNoun: "聖書",
    bibleDescription: "聖書、聖典、その他の宗教文書",

    tedTalkName: "TED Talk",
    tedTalkTitle: "TED Talk",
    tedTalkPhrase: "TED Talk",
    tedTalkNoun: "TED Talk",
    tedTalkDescription: "TED Talkと録画された会議講演",

    emailName: "メール",
    emailTitle: "メール",
    emailPhrase: "メール",
    emailNoun: "メール",
    emailDescription: "メール、手紙、その他の私信",

    redditName: "Redditまたはフォーラムの投稿",
    redditTitle: "Redditまたはフォーラムの投稿",
    redditPhrase: "Redditの投稿",
    redditNoun: "Redditの投稿",
    redditDescription:
      "Redditのスレッド、AMA、オンラインフォーラムや掲示板の投稿",

    tweetName: "X（Twitter）の投稿",
    tweetTitle: "X（Twitter）の投稿",
    tweetPhrase: "Xの投稿",
    tweetNoun: "Xの投稿",
    tweetDescription: "ツイートおよびX（旧Twitter）の投稿",

    mapName: "地図",
    mapTitle: "地図",
    mapPhrase: "地図",
    mapNoun: "地図",
    mapDescription: "印刷された地図、地図帳、Google Mapsなどのデジタル地図",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription: "Claudeとの対話やその他のAnthropic製AIの出力",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "Google Geminiとの対話とAIの出力",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription: "Microsoft Copilotとの対話とAIの回答",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription: "PerplexityのAI回答、スレッド、引用元の情報源",

    aiImageName: "AI生成画像",
    aiImageTitle: "AI生成画像",
    aiImagePhrase: "AI生成画像",
    aiImageNoun: "AI生成画像",
    aiImageDescription:
      "DALL·E、Midjourney、GeminiなどのAIツールで作成した画像",

    tiktokName: "TikTok動画",
    tiktokTitle: "TikTok動画",
    tiktokPhrase: "TikTok動画",
    tiktokNoun: "TikTok動画",
    tiktokDescription: "TikTok動画とクリエイターの投稿",

    instagramName: "Instagramの投稿",
    instagramTitle: "Instagramの投稿",
    instagramPhrase: "Instagramの投稿",
    instagramNoun: "Instagramの投稿",
    instagramDescription: "Instagramの投稿、リール、ストーリーズ",

    statuteName: "法律・法令",
    statuteTitle: "法律・法令",
    statutePhrase: "法律・法令",
    statuteNoun: "法律・法令",
    statuteDescription: "議会の制定法、法令、法典化された法律",

    isoStandardName: "ISO規格",
    isoStandardTitle: "ISO規格",
    isoStandardPhrase: "ISO規格",
    isoStandardNoun: "ISO規格",
    isoStandardDescription: "ISO、IECなどの公表された技術規格",

    quranName: "クルアーン（コーラン）",
    quranTitle: "クルアーン（コーラン）",
    quranPhrase: "クルアーン（コーラン）",
    quranNoun: "クルアーン",
    quranDescription: "アラビア語原典または翻訳のクルアーン",

    ebookNoPageNumbersName: "ページ番号のない電子書籍",
    ebookNoPageNumbersTitle: "ページ番号のない電子書籍",
    ebookNoPageNumbersPhrase: "ページ番号のない電子書籍",
    ebookNoPageNumbersNoun: "ページ番号のない電子書籍",
    ebookNoPageNumbersDescription:
      "固定のページ番号がないKindle、EPUB、オンライン電子書籍",

    speechName: "演説・スピーチ",
    speechTitle: "演説・スピーチ",
    speechPhrase: "演説・スピーチ",
    speechNoun: "演説・スピーチ",
    speechDescription: "演説、講演、説教（ライブまたは録音・録画）",

    letterName: "書簡",
    letterTitle: "書簡",
    letterPhrase: "書簡",
    letterNoun: "書簡",
    letterDescription: "刊行された書簡、アーカイブ所蔵の書簡、公開書簡",

    secondarySourceName: "二次資料（孫引き）",
    secondarySourceTitle: "二次資料（孫引き）",
    secondarySourcePhrase: "二次資料（孫引き）",
    secondarySourceNoun: "二次資料",
    secondarySourceDescription:
      "他の文献で引用・言及されているのを見つけた資料",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "見つかりません",
    fieldMetaTitle: "{field}の引用スタイル－おすすめの参照スタイル [2026]",
    fieldMetaDescription:
      "{field}でよく使われる引用スタイルをご紹介します。{fieldLower}の論文・学位論文・投稿原稿に適した参照書式を見つけましょう。",
    fieldOgTitle: "{field}の引用スタイル",
    fieldOgSubtitle: "よく求められるスタイル：{styles}。",
    fieldOgKind: "学問分野別",
    fieldKeywordStyle: "{field} 引用スタイル",
    fieldKeywordReferencing: "{field} 参照方式",
    fieldKeywordBest: "{fieldLower}に最適な引用スタイル",
    fieldKeywordBibliography: "{fieldLower} 参考文献の書式",
    fieldKeywordDiscipline: "学問分野別の引用スタイル",
    fieldBackLink: "← すべての引用スタイル",
    fieldHeading: "{field}の引用スタイル",
    fieldRecommendedHeading: "おすすめの引用スタイル",
    fieldRecommendedIntro:
      "以下は、{field}の研究・学術誌・課題でよく使われる引用スタイルです。スタイルを選んで詳細を確認し、引用の作成を始めましょう。",
    fieldStyleFallback: "{field}および関連分野で使われる引用スタイルです。",
    fieldRelatedHeading: "関連分野",
    fieldRelatedIntro: "関連する学問分野で使われている引用スタイルを見る：",
    fieldCtaHeading: "すべての引用スタイルを見る",
    fieldCtaBody:
      "CitationEasy はあらゆる学問分野にわたる {count} 種類の引用スタイルに対応しています。全スタイルを見て、必要な書式を見つけましょう。",
    fieldCtaButton: "すべてのスタイルを見る →",
    fieldFaqWhichQ: "{field}ではどの引用スタイルが使われますか？",
    fieldFaqWhichA:
      "{field}で使われる引用スタイルは、投稿先の学術誌や所属機関、指導教員の指示によって異なります。よく使われるスタイルには{styles}があります。必ず課題の指示や投稿先の学術誌で、指定の書式を確認してください。",
    fieldFaqSameQ: "{field}の学術誌はすべて同じスタイルを使いますか？",
    fieldFaqSameA:
      "いいえ、{field}の学術誌がすべて同じ引用スタイルを使うわけではありません。分野内でよく使われるスタイルはあっても、個々の学術誌が独自の書式規定を設けている場合があります。原稿を準備する前に、必ず投稿先の学術誌の投稿規定を確認してください。",
    fieldFaqChooseQ: "{field}の論文にはどの引用スタイルを選べばよいですか？",
    fieldFaqChooseA:
      "{field}の論文の引用スタイルを選ぶには、まず指導教員や投稿先の学術誌が指定するスタイルがあるかを確認してください。指定がない場合は、上記の{field}でよく推奨されるスタイルのいずれかを使用してください。CitationEasy は {count} 種類を超えるスタイルに対応しており、どれでも無料で引用を作成できます。",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "国が見つかりません",
    countryMetaTitle: "{country}の引用スタイル－APA、MLA ほか",
    countryMetaDescription:
      "{country}で使われる引用スタイルを見る。{country}の書式に対応した無料の引用ジェネレーターです。",
    countryOgTitle: "{country}で使われる引用スタイル",
    countryOgKind: "国別",
    countryHeading: "{country}の引用スタイル",
    countryIntroOne:
      "{country}でよく使われる、または関連する引用スタイルが {count} 件あります。選択すると専用のジェネレーターが開きます。",
    countryIntroMany:
      "{country}でよく使われる、または関連する引用スタイルが {count} 件あります。選択すると専用のジェネレーターが開きます。",
    countryBrowserTitle: "{country}の引用スタイル",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "種類が見つかりません",
    typeMetaTitle: "{type}の引用スタイル－無料ジェネレーター",
    typeMetaDescription:
      "{typeLower}向けの引用スタイル。APA、MLA、バンクーバーほか。無料の引用ジェネレーターです。",
    typeOgTitle: "{type}の引用スタイル",
    typeOgKind: "分野別",
    typeHeading: "{type}の引用スタイル",
    typeIntroOne:
      "{typeLower}向けの引用スタイルが {count} 件あります。選択すると、FAQ付きの専用ジェネレーターが開きます。",
    typeIntroMany:
      "{typeLower}向けの引用スタイルが {count} 件あります。選択すると、FAQ付きの専用ジェネレーターが開きます。",
    typeBrowserTitle: "{type}の引用スタイル",

    // ---- Shared chrome ----
    breadcrumbStyles: "引用スタイル",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "引用スタイル",
    breadcrumbByCountry: "国別",
    breadcrumbByDiscipline: "分野別",
    allStylesLink: "← すべての引用スタイル",
    internationalLabel: "国際的",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "心理学",
    education: "教育学",
    sociology: "社会学",
    anthropology: "人類学",
    politicalScience: "政治学",
    economics: "経済学",
    business: "経営学・ビジネス",
    literature: "文学・語学",
    history: "歴史学",
    philosophy: "哲学",
    law: "法学",
    medicine: "医学・臨床医学",
    nursing: "看護学・助産学",
    publicHealth: "公衆衛生学・疫学",
    pharmacy: "薬学",
    biology: "生物学・生命科学",
    chemistry: "化学",
    physics: "物理学",
    engineering: "工学",
    computerScience: "コンピュータサイエンス",
    mathematics: "数学・統計学",
    environmentalScience: "環境科学",
    earthScience: "地球科学・地質学",
    artHistory: "美術史・視覚芸術",
    music: "音楽学",
    theology: "神学・宗教学",
    socialWork: "ソーシャルワーク",
    linguistics: "言語学",
    architecture: "建築学・都市計画",
    filmMedia: "映画・メディア学",
    journalism: "ジャーナリズム・コミュニケーション学",
    criminology: "犯罪学・刑事司法",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "心理学、行動科学、認知科学の研究でよく使われる引用スタイルです。",
    education:
      "教育学の研究、教授法、カリキュラム研究で使われる引用スタイルです。",
    sociology: "社会学の研究や社会理論で使われる引用スタイルです。",
    anthropology: "人類学・民族誌学の研究で使われる引用スタイルです。",
    politicalScience:
      "政治学、行政学、公共政策研究で使われる引用スタイルです。",
    economics: "経済学・計量経済学の研究で使われる引用スタイルです。",
    business:
      "経営学、マネジメント、マーケティング、財務の研究で使われる引用スタイルです。",
    literature: "文学研究、言語学、語学研究で使われる引用スタイルです。",
    history: "歴史研究、史学史、文書館学の研究で使われる引用スタイルです。",
    philosophy: "哲学の論文や倫理学研究で使われる引用スタイルです。",
    law: "裁判資料、法学評論、法学研究で使われる法律引用スタイルです。",
    medicine: "医学研究、臨床研究、医療の分野で使われる引用スタイルです。",
    nursing: "看護学研究や医療実践で使われる引用スタイルです。",
    publicHealth: "公衆衛生学研究や疫学研究で使われる引用スタイルです。",
    pharmacy: "薬学・薬理学研究で使われる引用スタイルです。",
    biology: "生物学研究、生態学、遺伝学で使われる引用スタイルです。",
    chemistry: "化学、生化学、材料科学研究で使われる引用スタイルです。",
    physics: "物理学、天体物理学、応用物理学研究で使われる引用スタイルです。",
    engineering: "工学や応用技術研究で使われる引用スタイルです。",
    computerScience:
      "コンピュータサイエンス、AI、ソフトウェア工学研究で使われる引用スタイルです。",
    mathematics: "数学、応用数学、統計学研究で使われる引用スタイルです。",
    environmentalScience:
      "環境研究や持続可能性研究で使われる引用スタイルです。",
    earthScience:
      "地質学、地球物理学、地球科学研究で使われる引用スタイルです。",
    artHistory: "美術史、視覚文化、博物館学研究で使われる引用スタイルです。",
    music: "音楽研究、音楽理論、演奏研究で使われる引用スタイルです。",
    theology: "神学・宗教学研究で使われる引用スタイルです。",
    socialWork: "ソーシャルワークの研究や実践で使われる引用スタイルです。",
    linguistics: "言語学、音声学、言語科学研究で使われる引用スタイルです。",
    architecture:
      "建築学、都市デザイン、都市計画研究で使われる引用スタイルです。",
    filmMedia:
      "映画、テレビ、メディア、コミュニケーション研究で使われる引用スタイルです。",
    journalism:
      "ジャーナリズム、メディア研究、コミュニケーション研究で使われる引用スタイルです。",
    criminology: "犯罪学・刑事司法研究で使われる引用スタイルです。",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "アメリカ合衆国",
    unitedKingdom: "イギリス",
    australia: "オーストラリア",
    canada: "カナダ",
    newZealand: "ニュージーランド",
    ireland: "アイルランド",
    southAfrica: "南アフリカ",
    germany: "ドイツ",
    france: "フランス",
    spain: "スペイン",
    italy: "イタリア",
    netherlands: "オランダ",
    belgium: "ベルギー",
    switzerland: "スイス",
    austria: "オーストリア",
    portugal: "ポルトガル",
    luxembourg: "ルクセンブルク",
    sweden: "スウェーデン",
    norway: "ノルウェー",
    denmark: "デンマーク",
    finland: "フィンランド",
    iceland: "アイスランド",
    poland: "ポーランド",
    czechRepublic: "チェコ",
    hungary: "ハンガリー",
    romania: "ルーマニア",
    russia: "ロシア",
    ukraine: "ウクライナ",
    greece: "ギリシャ",
    turkey: "トルコ",
    croatia: "クロアチア",
    slovenia: "スロベニア",
    slovakia: "スロバキア",
    serbia: "セルビア",
    bulgaria: "ブルガリア",
    lithuania: "リトアニア",
    latvia: "ラトビア",
    estonia: "エストニア",
    japan: "日本",
    china: "中国",
    southKorea: "韓国",
    india: "インド",
    singapore: "シンガポール",
    hongKong: "香港",
    taiwan: "台湾",
    malaysia: "マレーシア",
    indonesia: "インドネシア",
    thailand: "タイ",
    vietnam: "ベトナム",
    philippines: "フィリピン",
    pakistan: "パキスタン",
    bangladesh: "バングラデシュ",
    sriLanka: "スリランカ",
    israel: "イスラエル",
    saudiArabia: "サウジアラビア",
    unitedArabEmirates: "アラブ首長国連邦",
    brazil: "ブラジル",
    mexico: "メキシコ",
    argentina: "アルゼンチン",
    chile: "チリ",
    colombia: "コロンビア",
    peru: "ペルー",
    venezuela: "ベネズエラ",
    egypt: "エジプト",
    nigeria: "ナイジェリア",
    kenya: "ケニア",
    morocco: "モロッコ",
    international: "国際的",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "医学",
    nursing: "看護学",
    publicHealth: "公衆衛生学",
    pharmacy: "薬学",
    dentistry: "歯学",
    veterinary: "獣医学",
    psychology: "心理学",
    sociology: "社会学",
    anthropology: "人類学",
    politicalScience: "政治学",
    economics: "経済学",
    education: "教育学",
    socialWork: "ソーシャルワーク",
    biology: "生物学",
    chemistry: "化学",
    physics: "物理学",
    environmentalScience: "環境科学",
    earthScience: "地球科学・地質学",
    agriculture: "農学",
    ecology: "生態学",
    engineering: "工学",
    computerScience: "コンピュータサイエンス",
    mathematics: "数学",
    statistics: "統計学",
    history: "歴史学",
    literature: "文学",
    philosophy: "哲学",
    linguistics: "言語学",
    artHistory: "美術史",
    music: "音楽学",
    filmMedia: "映画・メディア学",
    archaeology: "考古学",
    law: "法学",
    business: "経営学",
    architecture: "建築学",
    religion: "宗教学・神学",
    geography: "地理学",
    general: "総合・学際",
    other: "その他",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "参考文献リスト",
    listWorksCited: "引用文献一覧",
    listReferences: "参考文献",
    listBibliography: "文献目録",
    listTableOfAuthorities: "判例・法令一覧",
    listReferencesCited: "引用参考文献",
    listLowerReferenceList: "参考文献リスト",
    listLowerWorksCited: "引用文献一覧",
    listLowerReferences: "参考文献",
    listLowerBibliography: "文献目録",
    listLowerTableOfAuthorities: "判例・法令一覧",
    listLowerReferencesCited: "引用参考文献",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(著者, 年)",
    inTextAuthorPage: "(著者 ページ)",
    inTextAuthorYear: "(著者 年)",
    inTextSuperscriptOrBracketed: "上付きまたは丸かっこの数字 (1)",
    inTextBracketedNumbers: "角かっこの数字 [1]",
    inTextSuperscriptNumbers: "上付き数字¹",
    inTextSuperscriptOrAuthorYear: "上付き数字または(著者 年)",
    inTextKeyBased: "キーによる参照",
    inTextSuperscriptOrAuthorCommaYear: "上付き数字または(著者, 年)",
    inTextFootnotesCaseLegislation: "判例・法令を記載する脚注",
    inTextFootnotesSignals: "シグナル語の略語を伴う脚注",
    inTextFootnotesPinpoint: "該当箇所を示す脚注",
    inTextParenNumbers: "丸かっこの数字 (1)",
    inTextItalicNumbers: "イタリック体の数字 (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "第4版",
    edition5th: "第5版",
    edition7th: "第7版",
    edition8th: "第8版",
    edition9th: "第9版",
    edition11th: "第11版",
    edition18th: "第18版",
    edition22nd: "第22版",
    editionCiteThemRight11th: "Cite Them Right 第11版",
    editionIcmjeStandard: "ICMJE標準",
    editionStandard: "標準",
    editionCurrent: "最新版",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "音響学",
    fieldAnthropology: "人類学",
    fieldAppliedPhysics: "応用物理学",
    fieldArchaeology: "考古学",
    fieldArts: "芸術",
    fieldAstrophysics: "天体物理学",
    fieldAustralianLaw: "オーストラリア法",
    fieldBiochemistry: "生化学",
    fieldBiology: "生物学",
    fieldBiomedicalSciences: "生物医学",
    fieldBiotechnology: "バイオテクノロジー",
    fieldBusiness: "ビジネス",
    fieldCellBiology: "細胞生物学",
    fieldChemicalEngineering: "化学工学",
    fieldChemistry: "化学",
    fieldClinicalResearch: "臨床研究",
    fieldComputerScience: "コンピュータサイエンス",
    fieldCondensedMatter: "物性物理学",
    fieldCourtDocuments: "裁判資料",
    fieldCriminology: "犯罪学",
    fieldCulturalStudies: "文化研究",
    fieldDemography: "人口学",
    fieldEcology: "生態学",
    fieldEducation: "教育学",
    fieldElectronics: "電子工学",
    fieldEngineering: "工学",
    fieldEnvironmentalScience: "環境科学",
    fieldEpidemiology: "疫学",
    fieldEthnography: "民族誌学",
    fieldGenetics: "遺伝学",
    fieldGeology: "地質学",
    fieldGlobalHealth: "グローバルヘルス",
    fieldHealthSciences: "健康科学",
    fieldHistory: "歴史学",
    fieldHumanities: "人文学",
    fieldInformationSystems: "情報システム学",
    fieldInformationTechnology: "情報技術",
    fieldInternationalRelations: "国際関係学",
    fieldJurisprudence: "法理学",
    fieldLanguages: "言語",
    fieldLaw: "法学",
    fieldLawReview: "法学評論",
    fieldLegalStudies: "法学研究",
    fieldLifeSciences: "生命科学",
    fieldLiterature: "文学",
    fieldMaterialsScience: "材料科学",
    fieldMathematics: "数学",
    fieldMedicine: "医学",
    fieldMolecularBiology: "分子生物学",
    fieldMultidisciplinary: "学際",
    fieldMultidisciplinaryScience: "学際科学",
    fieldNaturalSciences: "自然科学",
    fieldNursing: "看護学",
    fieldPharmacy: "薬学",
    fieldPhysics: "物理学",
    fieldPoliticalScience: "政治学",
    fieldPsychology: "心理学",
    fieldPublicHealth: "公衆衛生学",
    fieldPublicPolicy: "公共政策",
    fieldPublishing: "出版学",
    fieldScience: "科学",
    fieldSciences: "諸科学",
    fieldSocialSciences: "社会科学",
    fieldSocialWork: "ソーシャルワーク",
    fieldSociology: "社会学",
    fieldSoftwareEngineering: "ソフトウェア工学",
    fieldTheology: "神学",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "社会科学で最も広く使われている引用スタイルです",
    mla: "人文学における標準的な引用スタイルです",
    chicago:
      "著者・編集者・出版者から最も信頼されているアメリカのスタイルガイドです",
    harvard: "イギリスとオーストラリアの大学で最も人気のある参照スタイルです",
    vancouver: "医学・生物医学系の学術誌で使われる標準的な引用スタイルです",
    ieee: "工学とコンピュータサイエンスの定番の引用スタイルです",
    ama: "アメリカの医学雑誌で使われる引用基準です",
    turabian: "Chicago スタイルを学生向けに簡略化したバージョンです",
    cse: "自然科学・物理科学分野で好んで使われる引用スタイルです",
    bibtex: "LaTeX ユーザーや学術組版で使われる文献目録の形式です",
    nature: "世界を代表する学際的学術誌で使われている引用スタイルです",
    acs: "化学・化学系科学分野の引用基準です",
    oscola:
      "イギリスの法科大学院や法律雑誌で使われる標準的な法律引用スタイルです",
    bluebook:
      "アメリカの裁判所や法学評論で使われる決定版の法律引用システムです",
    aglc: "オーストラリアの法科大学院や裁判所で使われる標準的な法律引用スタイルです",
    asa: "社会学・社会科学研究で使われる標準的な引用スタイルです",
    apsa: "政治学研究や学術誌で使われる引用スタイルです",
    aaa: "人類学研究で使われる標準的な引用スタイルです",
    nlm: "PubMed とアメリカ国立医学図書館で使われる引用基準です",
    acm: "ACM のカンファレンスやコンピューティング研究で使われる引用スタイルです",
    aps: "Physical Review や APS 系学術誌で使われる引用スタイルです",
    aip: "AIP や物理学系学術誌で使われる引用スタイルです",
    cell: "Cell Press や主要な生物学系学術誌で使われる引用スタイルです",
    science: "Science 誌や AAAS 系学術誌で使われる引用スタイルです",
    plos: "PLOS のオープンアクセス学術誌で使われる引用スタイルです",
    bmj: "BMJ やイギリスの主要な医学雑誌で使われる引用スタイルです",
    lancet: "The Lancet 系の医学雑誌で使われる引用スタイルです",
    jama: "JAMA および JAMA Network 系学術誌で使われる引用スタイルです",
    elsevierHarvard:
      "Elsevier 系の学術誌全般で使われる Harvard スタイルの派生形です",
    springer: "Springer Nature の学術誌や書籍で使われる引用スタイルです",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "見つかりません",
    metaTitle: "{a} と {b} の違い－主な相違点を解説 [2026]",
    metaDescription:
      "{a} と {b} の引用スタイルを並べて比較します。書式、文中引用、文献リストの主な違いを理解し、論文に適したスタイルを選びましょう。",
    ogTitle: "{a} と {b}",
    ogSubtitle:
      "文中引用の形式、文献リストの項目、大文字・小文字の使い方、それぞれが求められる分野を比較します。",
    ogKind: "スタイル比較",
    keywordVs: "{a} と {b}",
    keywordVersus: "{a} 対 {b}",
    keywordDifference: "{a} と {b} の違い",
    keywordOr: "{a} または {b}",
    keywordComparison: "引用スタイル比較",
    breadcrumbCompare: "スタイルを比較",
    breadcrumbCurrent: "{a} と {b}",
    backLink: "← 比較ツールに戻る",
    heading: "{a} と {b}：主な違い",
    intro:
      "{a} と {b} は学術界で最も広く使われている引用スタイルの2つですが、重要な点で異なります。{introA} {introB} 違いを理解することで、論文に適した書式を選びやすくなります。",
    styleIntro: "{style}（{fullName}）は{tagline}。",
    styleIntroFallback:
      "{style} は、多くの学問分野で使われている人気の引用スタイルです。",
    tableHeading: "スタイルの比較表",
    tableFeature: "項目",
    tableCitationSystem: "引用方式",
    tableInText: "文中引用の形式",
    tableReferenceList: "文献リストの名称",
    tableEdition: "版",
    tableCommonFields: "主な分野",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "著者・年方式",
    systemNumbered: "番号方式",
    systemFootnotes: "脚注方式",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "括弧内著者・年方式",
    describeNumbered: "番号方式",
    describeFootnotes: "脚注方式",
    whenToUseHeading: "{style} を使う場面",
    whenToUseBody:
      "{style}（{fullName}）は{system}を採用しており、文中引用には{inText}を用い、論文末尾に{list}を付けます。主に{fields}{more}で使用されています。",
    whenToUseMoreFields: "、および関連分野",
    whenToUseFallback:
      "{style} は広く認知されている引用スタイルです。{style} が指定の書式かどうか、課題の指示や投稿先の学術誌で確認してください。",
    ctaHeading: "実際の違いを見てみましょう",
    ctaBodyBefore: "ぜひ",
    ctaBodyLink: "インタラクティブな比較ツール",
    ctaBodyAfter:
      "をお試しください。ご自身の資料を使って {a} と {b} の引用を並べて比較できます。",
    ctaCiteIn: "{style} で引用する →",
    faqDifferenceQ: "{a} と {b} の違いは何ですか？",
    faqDifferenceA:
      "{a} と {b} は、文中引用の形式、文献リストの構成、使用される学問分野において異なります。{detail}",
    faqDifferenceDetail:
      "{a} は{inTextA}の文中引用と{listA}を用いるのに対し、{b} は{inTextB}と{listB}を用います。",
    faqDifferenceDetailFallback:
      "それぞれのスタイルには、引用の書式、文献リストの構成、資料タイプごとの扱いに関する独自のルールがあります。",
    faqBetterQ: "{a} と {b} ではどちらが優れていますか？",
    faqBetterA:
      "{a} と {b} のどちらが本質的に優れているということはありません。適切な選択は、学問分野、指導教員の指示、投稿先の学術誌によって異なります。どちらのスタイルを使うべきかは、課題の指示や投稿先の刊行物で確認してください。",
    faqSwitchQ: "{a} と {b} を切り替えることはできますか？",
    faqSwitchA:
      "はい、CitationEasy の無料引用ジェネレーターを使えば {a} と {b} を切り替えられます。希望のスタイルを選択するだけで、引用が自動的に再整形されます。ただし、指導教員から特別な指示がない限り、1つの論文では1つのスタイルのみを使用してください。",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "コンバーターが見つかりません",
    metaTitle: "{title}－無料・即時変換",
    ogTitle: "{title}",
    ogKind: "コンバーター",
    breadcrumbConverters: "コンバーター",
    breadcrumbLabel: "パンくずリスト",
    whenHeading: "こんなときに便利です",
    relatedHeading: "関連コンバーター",
    allConverters: "すべてのコンバーター",
    formatConverterTool: "引用形式コンバーター",
    faqHowQ: "{input} を {output} に変換するにはどうすればよいですか？",
    faqHowA:
      "{intro} すべて無料で、アカウント登録も変換回数の制限もありません。",
    faqPrivacyQ: "データはどこかにアップロードされますか？",
    faqPrivacyIdentifier:
      "各 {input} は、該当する公開メタデータサービス（DOI は Crossref、PMID は PubMed、ISBN は図書館の書誌データ）に照会されます。送信されるのは識別子そのものだけで、お使いの文書が送信されることはありません。整形結果はコピーまたはダウンロードでき、何も保存されません。",
    faqPrivacyLocal:
      "いいえ－貼り付けまたはアップロードした {input} は、すべてブラウザー内で解析されます。{detail}",
    faqPrivacyDetailStyle:
      "引用を作成するために整形ツールへ送信されるのは、解析済みの項目（著者名、タイトル、発行年）のみです。ファイル自体がお使いの端末の外へ送信されることはありません。",
    faqPrivacyDetailOffline:
      "変換はページ内で完全にオフラインで行われ、サーバーへは何も送信されません。",
    faqUsefulQ:
      "{input} から {output} への変換はどのようなときに役立ちますか？",
    faqOtherQ: "他のスタイルや形式にも変換できますか？",
    faqOtherA:
      "はい。CitationEasy のジェネレーターは、あらゆる資料を {count} 種類の引用スタイルで整形できます。文献リストは Word、RTF、BibTeX、RIS、CSL-JSON として書き出せ、コンバーターハブにはすべての直接変換ペアが一覧表示されています。すでに整形済みのテキストをスタイル間で書き換えたい場合は、引用形式コンバーターをご利用ください。",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "DOI から APA への引用コンバーター",
    doiToApaMetaDescription:
      "DOI を1行ずつ貼り付けるだけで、出版社公式の Crossref メタデータから正確な APA 第7版の参考文献を即座に生成します。無料・登録不要。",
    doiToApaIntro:
      "DOI はすでに出版社の正式なメタデータを指し示しているため、APA の参考文献を手入力する必要はありません。DOI を1行に1件ずつ貼り付ければ、著者名の倒置、文頭ケースのタイトル、イタリック体の雑誌名、そして APA が求める https://doi.org/ リンクまで揃った完全な APA 第7版の参考文献が得られます。",
    doiToApaUseCase:
      "よくある場面：教授から APA 形式の参考文献リストを求められたのに、手元にあるのは読書中に保存した DOI の山だけ、というとき。まとめて貼り付ければ、あとはリストをコピーするだけです。",
    doiToMlaTitle: "DOI から MLA への引用コンバーター",
    doiToMlaMetaDescription:
      "Crossref のメタデータを使って、DOI を自動的に MLA 第9版の引用文献一覧の項目に変換します。DOI を1行に1件貼り付けるだけ－無料、インストール不要。",
    doiToMlaIntro:
      "MLA 第9版は雑誌論文を「コンテナの連鎖」として扱います－引用符付きの論文タイトル、イタリック体の雑誌名、巻号、年、ページと、手作業でそろえるのは意外と面倒です。DOI 検索なら出版社の記録からすべての項目を埋めてくれるので、引用文献一覧の項目が一度で正しく仕上がります。",
    doiToMlaUseCase:
      "人文学系の授業で MLA が指定されているのに、資料は理系寄りのデータベースから DOI しか手に入らない、というときに便利です。",
    doiToBibtexTitle: "DOI から BibTeX へのコンバーター",
    doiToBibtexMetaDescription:
      "DOI を LaTeX や Overleaf 向けの BibTeX エントリに変換します。DOI を1行に1件貼り付けて、完成した .bib ファイルをダウンロード－無料、回数制限なし。",
    doiToBibtexIntro:
      "LaTeX の論文には、いずれ .bib ファイルが必要になります。DOI を1行ずつ貼り付ければ、生成された引用キー付きのきれいな @article エントリが得られ、Overleaf、natbib、biblatex にそのまま使えます－出版社のページから項目を手作業でコピーする必要はありません。",
    doiToBibtexUseCase:
      "よくある流れ：査読者から引用すべき論文を3本渡され、手元にあるのは DOI だけ、締め切りは今夜。貼り付けて、ダウンロードして、あとは \\cite するだけです。",
    doiToRisTitle: "DOI から RIS へのコンバーター",
    doiToRisMetaDescription:
      "DOI を Zotero、Mendeley、EndNote が直接取り込める RIS ファイルに変換します。DOI を1行に1件貼り付けるだけ－無料、登録不要。",
    doiToRisIntro:
      "RIS はあらゆる文献管理ソフトが取り込める交換フォーマットです。DOI を貼り付ければ、TY/AU/TI/T2 の各項目が Crossref から直接反映された .ris ファイルをダウンロードできます－あとは Zotero、Mendeley、EndNote で「ファイル→インポート」すれば、項目が完全に構造化された状態で取り込まれます。",
    doiToRisUseCase:
      "手作業で集めた DOI のリストを、きちんとした文献管理ソフトに移行するのに最適です。著者名を1件も打ち直す必要はありません。",
    isbnToApaTitle: "ISBN から APA への引用コンバーター",
    isbnToApaMetaDescription:
      "ISBN を自動的に APA 第7版の書籍の参考文献に変換します。ISBN を1行に1件貼り付けて、整形済みのリストをコピー－無料、登録不要。",
    isbnToApaIntro:
      "本の奥付にある ISBN さえあれば、APA の参考文献はそれで十分です。各 ISBN は図書館のメタデータと照合され、著者名、発行年、イタリック体のタイトル、出版社まで含めて APA 第7版の書式に整形されます－記録に版情報があれば、それも反映されます。",
    isbnToApaUseCase:
      "手元にある紙の図書館本をまとめて引用するなら最速の方法です。それぞれの奥付を開いて ISBN を入力し、ここにまとめて貼り付けるだけです。",
    isbnToMlaTitle: "ISBN から MLA への引用コンバーター",
    isbnToMlaMetaDescription:
      "ISBN を一度貼り付けるだけで MLA 第9版の引用文献一覧の項目に変換します。無料の ISBN 検索で整形済みの出力が得られます－登録不要。",
    isbnToMlaIntro:
      "MLA 第9版の書籍項目は短く－著者名、イタリック体のタイトル、出版社、発行年－ですが、著者名の倒置や句読点を正しく整えるのは意外とつまずきやすいところです。ISBN 検索なら本の実際の目録データを取得し、MLA ハンドブックの主要要素テンプレートに沿って整形します。",
    isbnToMlaUseCase:
      "文学のレポートに最適です。机の上の小説や研究書をすべて引用するのに、必要なのは裏表紙の番号を入力するだけです。",
    isbnToBibtexTitle: "ISBN から BibTeX へのコンバーター",
    isbnToBibtexMetaDescription:
      "ISBN を LaTeX 向けの BibTeX の @book エントリに変換します。ISBN を1行に1件貼り付けて、.bib ファイルをダウンロード－無料・即時。",
    isbnToBibtexIntro:
      "書籍は BibTeX の中でも扱いにくい存在です－調べるべき DOI はなく、出版社のページが .bib の書き出しに対応していることもほとんどありません。このコンバーターは各 ISBN を図書館のメタデータと照合し、著者、タイトル、出版社、発行年の各項目が入った @book エントリを生成します。",
    isbnToBibtexUseCase:
      "論文執筆者向け：方法論の章では雑誌の DOI を引用するけれど、理論の章では書籍を12冊引用する、というときに。その12冊はこちらで処理できます。",
    pmidToApaTitle: "PMID から APA への引用コンバーター",
    pmidToApaMetaDescription:
      "PubMed ID を自動的に APA 第7版の参考文献に変換します。PMID を1行に1件貼り付けて、整形済みの参考文献リストを取得－無料。",
    pmidToApaIntro:
      "PubMed のすべての記録には PMID が付いており、心理学や看護学の課程の多くは APA を指定します。PMID を1行ずつ貼り付ければ、PubMed 自身のメタデータを通じて完全な APA 第7版の雑誌論文の参考文献が得られます－記録に DOI があれば、そのリンクも含まれます。",
    pmidToApaUseCase:
      "エビデンスに基づく実践の課題に最適です。検索戦略の結果は PMID のリストで終わるのに、論文には APA 形式で書く必要がある、というときに。",
    pmidToRisTitle: "PMID から RIS へのコンバーター",
    pmidToRisMetaDescription:
      "PubMed ID を Zotero、Mendeley、EndNote 向けの RIS ファイルに変換します。PMID を1行に1件貼り付けて、.ris をダウンロード－無料。",
    pmidToRisIntro:
      "システマティックレビューの作業は RIS ファイルを中心に進みます。PubMed の検索結果から PMID を貼り付ければ、スクリーニングツールや文献管理ソフトにそのまま使える .ris をダウンロードできます－各記録は、スクレイピングしたテキストではなく PubMed 自身の正式なメタデータから構造化されています。",
    pmidToRisUseCase:
      "レビューの途中で、同僚から「この5件の研究も追加して」と PMID だけがメールで届き、自分の文献は EndNote で管理している、というときに役立ちます。",
    arxivToBibtexTitle: "arXiv から BibTeX へのコンバーター",
    arxivToBibtexMetaDescription:
      "arXiv ID を LaTeX 論文向けの BibTeX エントリに変換します。2301.12345 のような ID を1行に1件貼り付けて、.bib をダウンロード－無料。",
    arxivToBibtexIntro:
      "変化の速い分野ではプレプリントが盛んに引用され、arXiv ID（例：2301.12345）はその流通手段です。ID を貼り付ければ、プレプリントの著者、タイトル、発行年、arXiv リンクを含む BibTeX エントリが得られ、論文の .bib ファイルにそのまま使えます。",
    arxivToBibtexUseCase:
      "関連研究の節の8割が arXiv という機械学習や物理学の執筆者向けに。読みながら ID を集めておき、執筆時にまとめて1回で変換できます。",
    bibtexToApaTitle: "BibTeX から APA へのコンバーター",
    bibtexToApaMetaDescription:
      ".bib ファイルを貼り付けるかアップロードするだけで APA 第7版の参考文献リストが得られます。複数エントリのファイルにも対応－無料、解析はブラウザー内で完結します。",
    bibtexToApaIntro:
      "論文が LaTeX を離れることもあります－学術誌から Word 原稿を求められたり、委員会が参考文献リストをプレーンテキストで欲しがったり。BibTeX を貼り付ける（または .bib をアップロードする）と、すべてのエントリがブラウザー内で解析され、どんな文書にもそのまま貼り付けられる APA 第7版の参考文献リストとして整形されます。",
    bibtexToApaUseCase:
      "助成金申請の定番パターン：業績リストは .bib ファイルで管理しているのに、申請フォームの入力欄は APA 形式の参考文献を求めている、というときに。",
    bibtexToMlaTitle: "BibTeX から MLA へのコンバーター",
    bibtexToMlaMetaDescription:
      "BibTeX を MLA 第9版の引用文献一覧の項目に変換します。.bib ファイルを貼り付けるかアップロードして、整形済みのリストをコピー－無料、登録不要。",
    bibtexToMlaIntro:
      "BibTeX は項目を生の情報として保持するだけですが、MLA はそれらをどう並べるかを厳密に定めています。このコンバーターは .bib のエントリをブラウザー内で解析し、それぞれを MLA 第9版のテンプレートに沿って整形します－著者名の倒置、引用符付きの論文タイトル、イタリック体のコンテナ名、要素間の正しい句読点まで。",
    bibtexToMlaUseCase:
      "両方の分野をまたぐ研究者向け：過去の LaTeX での研究成果は BibTeX にまとまっているのに、投稿先の人文学系の学術誌は MLA を求めている、というときに。",
    bibtexToRisTitle: "BibTeX から RIS へのコンバーター",
    bibtexToRisMetaDescription:
      ".bib ファイルを Zotero、Mendeley、EndNote 向けの RIS に変換します。BibTeX を貼り付けるかアップロードして、.ris をダウンロード－無料、オフラインで動作します。",
    bibtexToRisIntro:
      "LaTeX のツールから文献管理ソフトへ移行するには、BibTeX の @article/@book エントリを RIS の TY/AU/TI タグに変換する必要があります。変換はすべてブラウザー内で完結し－項目のマッピングも含めて－どの文献管理ソフトでも取り込める .ris ファイルが手に入ります。",
    bibtexToRisUseCase:
      "よくあるきっかけ：新しい共著者が Zotero を使っていて、共有の文献リストはリポジトリ内の .bib ファイル、誰かがその橋渡しをしなければならない、というときに。",
    bibtexToCslJsonTitle: "BibTeX から CSL-JSON へのコンバーター",
    bibtexToCslJsonMetaDescription:
      "BibTeX を Pandoc や Quarto 向けの CSL-JSON に変換します。.bib を貼り付けるかアップロードして、references.json をダウンロード－無料、ブラウザー内で完結。",
    bibtexToCslJsonIntro:
      "Pandoc と Quarto は CSL-JSON をネイティブに引用元として扱えるため、既存の .bib を変換しておけば、ビルドから可動部分を1つ取り除けます。エントリはブラウザー内で解析され、--bibliography=references.json がまさに求めるとおりの、きれいな CSL-JSON 配列として出力されます。",
    bibtexToCslJsonUseCase:
      "古い LaTeX プロジェクトを Quarto に移行する Markdown 中心の研究者向け：JSON を手で編集することなく、文献リストをそのまま持ち込めます。",
    bibtexToWordTitle: "BibTeX から Word へのコンバーター",
    bibtexToWordMetaDescription:
      ".bib ファイルを、APA 形式・ぶら下げインデントの参考文献リスト付きの Word 文書に変換します。無料－解析はブラウザー内で行われます。",
    bibtexToWordIntro:
      ".bib ファイルを別のデータ形式ではなく文書そのものにしたいとき、このコンバーターは BibTeX をローカルで解析し、すべてのエントリを APA 第7版で整形したうえで、すでにアルファベット順に並べぶら下げインデントも設定済みの参考文献リスト入り Word ファイルをダウンロードします。",
    bibtexToWordUseCase:
      "パイプラインの最終段階でよくある場面：学術誌には論文が採択されたものの、最終的な参考文献リストは編集可能な Word ファイルで求められ、情報の元は BibTeX だけ、というときに。",
    risToApaTitle: "RIS から APA へのコンバーター",
    risToApaMetaDescription:
      "RIS のエクスポートファイルを貼り付けるかアップロードするだけで APA 第7版の参考文献リストが得られます。Zotero、Mendeley、EndNote、データベースのエクスポートに対応－無料。",
    risToApaIntro:
      "どのデータベースの「エクスポート」ボタンも RIS を出力しますが、課題では APA が求められます。エクスポートファイルを貼り付ける（または .ris をアップロードする）と、TY/AU/TI の各記録がブラウザー内で解析され、APA 第7版の参考文献として整形されます－文献管理ソフトのインストールは不要です。",
    risToApaUseCase:
      "図書館データベースの近道：検索結果を RIS としてエクスポートし、ここで変換すれば、1回きりの論文のために Zotero を準備する手間を省けます。",
    risToMlaTitle: "RIS から MLA へのコンバーター",
    risToMlaMetaDescription:
      "データベースや文献管理ソフトからの RIS エクスポートを、MLA 第9版の引用文献一覧の項目に変換します。貼り付けまたはアップロード－無料、登録不要。",
    risToMlaIntro:
      "JSTOR、ProQuest、EBSCO はどれも RIS を出力しますが、英文学系の学部はどこも MLA を求めます。このページはそのギャップを埋めます－記録はローカルで解析され、MLA 第9版の主要要素テンプレートに沿って整形されるので、そのまま引用文献一覧のページに貼り付けられます。",
    risToMlaUseCase:
      "レポート提出前夜のために：JSTOR から citations.ris としてエクスポートした10件の資料を、手作業で整形したくないときに。",
    risToBibtexTitle: "RIS から BibTeX へのコンバーター",
    risToBibtexMetaDescription:
      "RIS を LaTeX や Overleaf 向けの BibTeX に変換します。.ris のエクスポートファイルを貼り付けるかアップロードして、きれいな .bib ファイルをダウンロード－無料、ブラウザー内で完結。",
    risToBibtexIntro:
      "LaTeX の方向へ進む場合：文献管理ソフトやデータベースは RIS で話しますが、論文のビルドには .bib が必要です。記録はすべてブラウザー内で変換され－TY タグから種類がマッピングされ、引用キーも生成されて－Overleaf がそのまま受け付けるファイルになります。",
    risToBibtexUseCase:
      "共同研究でよくあるパターン：Zotero を使う人が RIS をエクスポートし、LaTeX を使う人がこのページに通す、それぞれが自分のツールを使い続けられます。",
    risToCslJsonTitle: "RIS から CSL-JSON へのコンバーター",
    risToCslJsonMetaDescription:
      "RIS のエクスポートを Pandoc や Quarto のパイプライン向けの CSL-JSON に変換します。.ris を貼り付けるかアップロードして、references.json をダウンロード－無料。",
    risToCslJsonIntro:
      "Pandoc や Quarto のユーザーにとって、CSL-JSON はネイティブの文献リスト形式です。データベースや文献管理ソフトが出力した RIS をこのページに渡せば、構造化された JSON 配列が返ってきます－すべての記録はローカルで解析され、どこにもアップロードされません。",
    risToCslJsonUseCase:
      "docs-as-code のワークフローにぴったりです：査読者は RIS 添付ファイルを送ってきて、リポジトリの文献ファイルは references.json、このページがその橋渡し役になります。",
    cslJsonToBibtexTitle: "CSL-JSON から BibTeX へのコンバーター",
    cslJsonToBibtexMetaDescription:
      "CSL-JSON（Pandoc/Quarto/Zotero のエクスポート）を BibTeX に変換します。.json を貼り付けるかアップロードして、.bib をダウンロード－無料、ブラウザー内で完結。",
    cslJsonToBibtexIntro:
      "流れが逆になることもあります－Pandoc や Zotero のパイプラインで生まれた文献リストを、LaTeX のビルドに取り込む必要があるときです。このコンバーターはブラウザー内で CSL-JSON 配列を読み込み、CSL モデルから種類と項目をマッピングし直した BibTeX エントリを出力します。",
    cslJsonToBibtexUseCase:
      "共著者が Overleaf を譲らない Quarto の執筆者向け：references.json を正本として保ちつつ、必要に応じて .bib を生成できます。",
    cslJsonToRisTitle: "CSL-JSON から RIS へのコンバーター",
    cslJsonToRisMetaDescription:
      "CSL-JSON を RIS に変換し、Zotero、Mendeley、EndNote で取り込めるようにします。.json を貼り付けるかアップロードして、.ris をダウンロード－無料。",
    cslJsonToRisIntro:
      "CSL-JSON は Pandoc のパイプライン内では申し分ありませんが、ほとんどの文献管理ソフトの取り込みダイアログには通じません。RIS に変換すれば、同じ記録をあらゆるソフトで取り込めるようになります－各項目はブラウザー内で TY/AU/TI タグにマッピングされ、サーバーには何も送信されません。",
    cslJsonToRisUseCase:
      "引き継ぎの悩みに：文献リストは git リポジトリ内の references.json なのに、指導教員からは金曜日までに「EndNote の形式で」と言われる、というときに。",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "すべての引用スタイル",
    styleSingular: "件のスタイル",
    stylePlural: "件のスタイル",
    found: "がヒットしました",
    filterPlaceholder: "スタイルを絞り込む…",
    noMatches: "該当するスタイルが見つかりませんでした。",
    loadingMore: "スタイルを読み込み中…",
    loadMore: "さらに読み込む（残り{count}件）",
    showingAll: "全{count}件のスタイルを表示中",
    internationalLabel: "国際的",
  },

  footer: {
    tagline:
      "{count} スタイルに対応した無料の引用文献ジェネレーター。アカウント不要、有料プラン不要、制限なし。",
    freeTools: "無料ツール",
    resources: "資料",
    legal: "各種規約",
    language: "言語",
    languageLabel: "言語を選択",
    rights: "引用は Citation Style Language の公式定義に基づいて整形されます。",
    popularStyles: "よく使われるスタイル",
    about: "サイトについて",
    privacy: "プライバシー",
    terms: "利用規約",
    contact: "お問い合わせ",
    copyright: "© {year} CitationEasy. 無料でご利用いただけます。",
    poweredBy: "技術提供：",
    allTools: "すべての執筆ツール",
    citationGuides: "引用ガイド",
    allStyles: "すべての引用スタイル",
    citationGlossary: "引用用語集",
    howToCiteAny: "あらゆる資料の引用方法",
  },

  faq: {
    heading: "よくある質問",
    homeQ1: "CitationEasy は本当に無料ですか？",
    homeA1:
      "はい。CitationEasy は完全に無料で、登録も利用制限も有料プランもありません。{count} 種類すべての引用スタイルを誰でも使えます。",
    homeQ2: "どの引用スタイルに対応していますか？",
    homeA2:
      "Citation Style Language プロジェクトの {count} スタイルすべてです。APA 第7版、MLA 第9版、Chicago、Harvard、Vancouver、IEEE、AMA、Turabian などが含まれます。",
    homeQ3: "アカウントは必要ですか？",
    homeA3:
      "不要です。CitationEasy はすべてブラウザー内で動作し、文献リストはお使いの端末に保存されます。サーバーへのアップロードはなく、登録する場所もありません。",
    homeQ4: "引用文献を自分の言語で作成できますか？",
    homeA4:
      "できます。引用文献の言語はサイトの表示言語とは別の設定なので、日本語で操作しながら、論文の言語に合わせた文献リストを出力できます。",
    styleQ1: "{style} の引用ジェネレーターは無料ですか？",
    styleA1:
      "はい。{style} 形式の引用文献の作成は無料・無制限で、アカウントも不要です。DOI、URL、ISBN、BibTeX を貼り付けて、できあがった文献情報をコピーしてください。",
    styleQ2: "{style} で出典を引用するにはどうすればよいですか？",
    styleA2:
      "出典の DOI、URL、ISBN、BibTeX をこのページのジェネレーターに貼り付けてください。{style} はあらかじめ選択されているので、文献リストの記載と本文中の引用がすぐに表示されます。",
    styleQ3: "{style} の書式はどの程度正確ですか？",
    styleA3:
      "すべての文献情報は、Citation Style Language プロジェクトが公開する公式の {style} 定義（Zotero や Mendeley が使うものと同じファイル）から生成されます。規則を近似したものではありません。",
  },

  tool: {
    modeLabel: "引用の入力方法",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "書籍を検索",
    modeArticles: "論文を検索",
    modeManual: "手入力",
    errorEnterManually: "詳細を手入力する",
    autoLabel: "URL・DOI・PMID・arXiv ID・ISBN・BibTeX を貼り付け",
    autoHint:
      "種類を自動判別してメタデータを取得します。1 行に 1 件ずつ貼り付けると、リストをまとめて引用できます。",
    generate: "引用を作成",
    generating: "作成中…",
    bookSearchLabel: "書名・著者名・ISBN で検索",
    bookSearchEmpty:
      "まだ結果がありません。「検索」を押して書籍を探してください。",
    bookSearchSource: "数百万冊を収録する Open Library の目録を検索します",
    worksSearchLabel: "論文タイトルまたは著者名で検索",
    worksSearchEmpty:
      "まだ結果がありません。「検索」を押して論文を探してください。",
    worksSearchSource:
      "Crossref の目録（学術雑誌論文・会議論文・書籍の章）を検索します",
    showingResults: "{total} 件中 {shown} 件を表示",
    search: "検索",
    searching: "検索中…",
    bulkResults: "一括引用の結果",
    copy: "コピー",
    copied: "コピーしました",
    copyHint: "コピーして論文に貼り付けてください",
    resultTitle: "書式化された引用",
    edit: "編集",
    completeFields: "補完する",
    fieldsIncomplete: "other:{count}件の項目が未入力",
    outputLanguage: "言語",
    sourceType: "資料の種類",
    fieldAuthors: "著者",
    fieldAuthorsHint: "山田 太郎 または Yamada, Taro",
    fieldTitle: "論文名または書名",
    fieldBookTitle: "書名",
    fieldBookTitleHint: "書籍または論文集の書名",
    fieldEditors: "編者",
    fieldJournal: "雑誌・刊行物",
    fieldJournalHint: "雑誌名または刊行物名",
    fieldPublisher: "出版社・サイト",
    fieldPublisherHint: "出版社名またはウェブサイト",
    fieldDate: "日付・年",
    fieldVolume: "巻",
    fieldIssue: "号",
    fieldPages: "ページ",
    fieldFormat: "形式・媒体",
    fieldAuthorsGroup: "団体・組織の著者",
    fieldAuthorsGroupHint:
      "個人と並べて団体を入れるときは波かっこで囲みます：{R Core Team}, Yamada, Taro",
    fieldTranslators: "翻訳者",
    fieldInterviewers: "インタビュアー",
    fieldVersion: "バージョン",
    fieldCourt: "裁判所",
    fieldIssuingAuthority: "発行機関",
    fieldPatentNumber: "特許番号",
    fieldEpisodeNumber: "エピソード番号",
    fieldLawNumber: "法律・法案番号",
    fieldReportNumber: "報告書番号",
    fieldReviewedTitle: "書評対象の作品名",
    fieldReviewedAuthors: "書評対象の著者",
    inTextCitation: "文中引用",
    quickEdit: "クイック編集",
    quickEditHint: "メタデータを更新して引用を作り直します。",
    update: "更新",
    saving: "保存中…",
    fieldAuthor: "著者",
    fieldDateShort: "日付",
    fieldTitleShort: "タイトル",
  },

  toolCollections: {
    "citation-generators": "引用ジェネレーター",
    "citation-tools": "引用・参考文献ツール",
    "paper-formatting": "論文の書式設定",
    "essay-writing": "小論文・レポート作成",
    "writing-analysis": "文章分析・校正",
    "word-counters": "カウンター・読みやすさ",
    vocabulary: "語彙・単語検索",
    "research-tools": "研究・出版",
    statistics: "統計計算ツール",
    math: "数学の計算ツール",
    science: "理科・実験の計算ツール",
    charts: "グラフ・図表",
    economics: "経済・ビジネス・金融",
    grades: "GPA・成績計算ツール",
    study: "学習・生産性",
    classroom: "授業・印刷用教材",
    random: "ランダム生成・抽選",
    "text-tools": "テキスト整形・クリーンアップ",
    "fancy-text": "装飾テキスト・記号",
    language: "言語・翻字",
    ciphers: "暗号・符号",
    converters: "単位・日付・数値の変換",
    developer: "データ・マークアップ・コード",
  },
  bib: {
    title: "マイ参考文献リスト",
    studioTitle: "参考文献スタジオ",
    studioProjects: "プロジェクト",
    studioExplore: "探す",
    studioExploreIntro:
      "ガイド、ツール、すべての引用スタイルにワンクリックで移動できます。",
    studioStyleGuide: "{style} スタイルガイド",
    studioStyleGuideHint: "ルール、実例、本文中の引用形式",
    studioGenerator: "引用ジェネレーター",
    studioNewProject: "新しいプロジェクト",
    studioSwitchProject: "プロジェクトを切り替え",
    studioAddSource: "文献を追加",
    studioAddSourceHint:
      "DOI・URL・ISBN を貼り付けるか、書籍や論文を検索するか、手入力してください。保存した文献はすべてこのプロジェクトに入ります。",
    studioDoneAdding: "追加を終了",
    studioReferences: "参考文献",
    studioReferenceCount: "{count} 件の文献",
    studioInspectorTitle: "文献の詳細",
    studioInspectorEmpty:
      "文献を選択すると、本文中の引用、メモ、出典の詳細を確認できます。",
    studioSavedLocally: "このブラウザーに保存済み",
    studioOpen: "参考文献スタジオを開く",
    studioViewInStudio: "スタジオで表示",
    studioFooterSaved: "参考文献スタジオに {count} 件保存済み",
    studioFooterEmpty: "保存した引用はスタジオで完全な参考文献リストになります",
    studioClearSelection: "選択を解除",
    studioDeleteSelected: "選択した項目を削除",
    studioDeleteSelectedBody:
      "「{name}」から {count} 件の引用を削除しますか？この操作は取り消せません。",
    studioDeletedMany: "{count} 件の引用を削除しました",
    studioMoveTo: "移動先",
    studioCopyTo: "コピー先",
    studioSearchShortcut: "/ キーで検索",
    studioStyle: "スタイル",
    studioCopyEntry: "項目をコピー",
    studioEntryCopied: "項目をコピーしました",
    studioSourceDetails: "出典の詳細",
    studioEmptyTitle: "このプロジェクトは空です",
    studioEmptyBody:
      "上で最初の文献を追加するか、既存の BibTeX・RIS・CSL-JSON ライブラリーを読み込んでください。",
    studioBackup: "バックアップ",
    sharedTitle: "共有された参考文献リスト",
    save: "保存",
    saving: "保存中…",
    saved: "保存しました",
    searchPlaceholder: "引用を検索…",
    empty: "保存された引用はまだありません",
    emptySearch: "検索条件に一致する引用はありません。",
    countIn: "{name}: {count} 件",
    savedOn: "{date} に保存",
    emptyInBib:
      "この参考文献リストにはまだ引用がありません。引用を作成して保存するか、既存の BibTeX・RIS・CSL-JSON ライブラリを読み込んでください。",
    savedToast: "引用を参考文献リストに保存しました",
    copyAll: "すべてコピー",
    copyAllTitle: "すべての引用をコピー",
    export: "書き出し",
    exportTitle: "参考文献リストを書き出す",
    import: "読み込み",
    importTitle: "文献を読み込む",
    importLabel: "文献を読み込む（BibTeX・RIS・CSL-JSON）",
    importing: "読み込み中…",
    importFailed: "読み込みに失敗しました。もう一度お試しください。",
    importSummary:
      "読み込み済み: {added} · 重複を除外: {duplicates} · 上限超過: {overLimit} · 失敗: {failed}",
    importUnreadable: "ファイルを読み取れませんでした。",
    importUnparseable: "文献を読み込めませんでした。",
    importReviewTitle: "読み込み内容を確認",
    importReviewIntro:
      "{total} 件の {format} 文献を、整形して保存する前に確認してください。",
    importReviewCount: "{total} 件中 {included} 件を含める",
    importSelectAll: "すべて含める",
    importExcludeAll: "すべて除外",
    importLimitNotice:
      "200 件の上限を超える {count} 件の文献は読み込まれません。",
    importDuplicateExisting:
      "保存済みの「{title}」と重複している可能性があります",
    importDuplicateBatch:
      "この読み込み内の「{title}」と重複している可能性があります",
    importMissingField: "{field}がありません",
    importUntitled: "タイトルのない文献",
    importReview: "文献を確認",
    importCommit: "整形して読み込む",
    importBack: "戻る",
    importOutcomeTitle: "読み込み完了",
    importOutcomeSummary:
      "追加: {added} · 重複を除外: {duplicates} · 対象外: {excluded} · 上限超過: {overLimit} · 失敗: {failed}",
    sortBy: "並べ替え",
    sortTitle: "参考文献リストを並べ替える",
    sortAuthor: "著者（A–Z）",
    sortNewest: "追加日（新しい順）",
    sortOldest: "年（古い順）",
    sortManual: "手動順",
    backupAll: "全プロジェクトのバックアップ（.json）",
    backupDownloaded: "全プロジェクトのバックアップをダウンロードしました",
    backupUnreadable: "バックアップファイルを読み込めませんでした。",
    restore: "復元",
    restoreTitle: "すべての参考文献プロジェクトを復元",
    restoreWarning:
      "最初にバックアップを検証し、その後、このブラウザーに保存されているすべての参考文献を置き換えます。この操作は元に戻せません。",
    restoreChoose: "CitationEasy バックアップを選択（.json）",
    replaceAndRestore: "置き換えて復元",
    restoreComplete: "すべての参考文献プロジェクトを復元しました",
    restoreInvalid:
      "有効な CitationEasy プロジェクトバックアップではありません。",
    selectAllVisible: "表示中をすべて選択",
    selectedCount: "{count} 件選択",
    clusterOpen: "まとめて引用",
    clusterTitle: "複合本文内引用",
    clusterDescription:
      "選択した参考文献から1つの引用クラスターを作成します。選択したスタイルが順序、句読点、番号付けを制御します。",
    clusterTarget: "出力",
    clusterLocatorOptional: "任意の位置指定",
    clusterBuildCopy: "引用を作成してコピー",
    clusterBuilding: "引用を作成中…",
    clusterCopied: "複合引用をコピーしました",
    clusterFailed: "複合引用を作成できませんでした。もう一度お試しください。",
    destination: "移動先の参考文献",
    chooseDestination: "参考文献を選択…",
    copySelected: "コピー",
    moveSelected: "移動",
    copyComplete:
      "{count} 件をコピーしました。重複 {skipped} 件をスキップしました。",
    moveComplete:
      "{count} 件を移動しました。重複 {skipped} 件は移動元に残りました。",
    selectCitation: "{title} を選択",
    moveUp: "上へ移動",
    moveDown: "下へ移動",
    deleteTitle: "引用を削除",
    deleteConfirm: "引用を削除しますか？",
    deleted: "引用を削除しました",
    editTitle: "引用を編集",
    close: "閉じる",
    copiedAll: "すべての引用をコピーしました",
    copiedAnnotated: "注釈付き参考文献リストをコピーしました",
    copiedBibtex: "BibTeX をコピーしました",
    copiedBulleted: "箇条書きをコピーしました",
    copiedNumbered: "番号付きリストをコピーしました",
    copiedHtml: "HTML をコピーしました",
    downloadedWord: "Word 文書をダウンロードしました",
    downloadedRtf: "RTF ファイルをダウンロードしました",
    downloadedRis: "RIS ファイルをダウンロードしました",
    downloadedCsl: "CSL-JSON ファイルをダウンロードしました",
    downloadedAnnotated: "注釈付き参考文献リストをダウンロードしました",
    copyFailed: "クリップボードにコピーできませんでした",
    shareCopied:
      "リンクをコピーしました。リンクを知っている人はこのリストを閲覧・読み込みできます。",
    shareFailed: "共有リンクを作成できませんでした",
    regenerateFailed: "引用を再生成できませんでした",
    updateFailed: "引用を更新できませんでした",
    fieldAuthor: "著者",
    fieldTitle: "タイトル",
    fieldDate: "日付",
    fieldPublisher: "出版社",
    fieldVolume: "巻",
    fieldIssue: "号",
    fieldPages: "ページ",
    fieldUrl: "URL",
    fieldAccessed: "参照日",
    fieldEditor: "編集者",
    fieldEvent: "開催地",
    noteLabel: "この資料への注釈",
    noteEdit: "この注釈を編集",
    notePlaceholder: "資料の要約と評価、そして自分の研究との関係を書きます…",
    noteRemoved: "注釈を削除しました",
    noteSave: "注釈を保存",
    noteCancel: "キャンセル",
    noteAdd: "注釈を追加",
    noteWords: "{count} 語",
    noteSaved: "注釈を保存しました（{count} 語）",
    noteClickToEdit: "クリックして編集",
    inTextCopy: "この資料の文中引用をコピー",
    inTextSelect: "下の引用を選択してコピーしてください。",
    inTextFailed: "文中引用を作成できませんでした。もう一度お試しください。",
    locator: "位置指定",
    locatorType: "位置の種類",
    locatorPage: "ページ",
    locatorChapter: "章",
    locatorSection: "節",
    locatorParagraph: "段落",
    locatorLine: "行",
    locatorVerse: "節（韻文）",
    reformat: "書式を変更",
    reformatTitle: "すべての引用を別のスタイルで作り直す",
    reformatHeading: "すべてを一つのスタイルに揃える",
    reformatChoose: "スタイルを選択…",
    reformatFailed:
      "書式変更に失敗しました。参考文献リストは変更されていません。",
    sortOrder: "並べ替えの基準",
    copyToClipboard: "クリップボードにコピー",
    numberedList: "番号付きリスト",
    bulletedList: "箇条書き",
    htmlSnippet: "HTML",
    copyWithAnnotations: "注釈付きでコピー",
    wordAnnotated: "注釈付き Word 文書（.doc）",
    downloadFile: "ファイルをダウンロード",
    wordDocument: "Word 文書（.doc）",
    copyShareLink: "共有リンクをコピー",
    print: "印刷…",
    printFailed: "ポップアップがブロックされました。印刷には許可が必要です",
    font: "フォント",
    sitePublication: "サイト / 出版物名",
    importIntro:
      "BibTeX（.bib）・RIS（.ris）・CSL-JSON（.json）を貼り付けるか、ファイルをアップロードします",
    importUpload: ".bib・.ris・.json ファイルをアップロード",
    importPaste: "または BibTeX・RIS・CSL-JSON を貼り付け",
    cancel: "キャンセル",
    done: "完了",
    delete: "削除",
    deleteBody: "この引用は参考文献リストから完全に削除されます。",
    editBody: "メタデータを更新して保存すると、引用が作り直されます。",
    reformatExplain:
      "保存済みの資料データから {count} 件すべてを作り直します。再ダウンロードは行われず、資料が失われることもありません。",
    inTextHeading: "文中引用",
    inTextLocatorHint:
      "ページなどの位置指定を加えると、資料内の特定の箇所を指す引用になります。直接引用では多くのスタイルで必須です。単純な形にするには空欄のままにしてください。",
    inTextCopyButton: "文中引用をコピー",
    mixedStyles:
      "この参考文献リストには {count} 種類の引用スタイルが混在しています（{styles}）。",
    mixedStylesAction: "提出前に {action} で一つのスタイルに揃えてください。",
    selectBibliography: "参考文献リストを選択",
    newBibliography: "新しい参考文献リスト",
    moreOptions: "その他の操作",
    rename: "名前を変更",
    removeDuplicates: "重複を削除",
    cannotDeleteOnly: "唯一の参考文献リストは削除できません",
    newBibliographyBody:
      "別の論文やプロジェクト用の参考文献リストを作成します。",
    bibliographyName: "参考文献リスト名",
    create: "作成",
    renameBibliography: "参考文献リストの名前を変更",
    renameBibliographyBody: "「{name}」の新しい名前を入力してください。",
    newName: "新しい名前",
    duplicateRemovedOne: "重複を {count} 件削除しました",
    duplicateRemovedMany: "重複を {count} 件削除しました",
    noDuplicates: "重複する文献は見つかりませんでした",
    removeDuplicatesConfirm: "重複する文献を削除しますか？",
    removeDuplicatesBody:
      "「{name}」から同じ資料（DOI、ISBN、またはタイトル・年・著者で照合）を探し、1 件だけ残します。照合できない文献は変更しません。",
    deleteBibliographyConfirm: "参考文献リストを削除しますか？",
    deleteBibliographyBody:
      "「{name}」と含まれる {count} 件の引用を完全に削除します。",
  },

  bibliographyPage: {
    metaTitle: "参考文献スタジオ－引用の整理・注釈・書き出し",
    metaDescription:
      "ブラウザーで非公開の参考文献プロジェクトを管理。アカウント不要で検索、並べ替え、注釈、編集、再整形、読み込み、書き出し、共有ができます。",
    keyword1: "参考文献作成",
    keyword2: "引用管理",
    keyword3: "注釈付き参考文献ツール",
    ogTitle: "参考文献スタジオ",
    ogDescription:
      "引用の整理、整形、注釈、読み込み、書き出しを行う非公開の全画面ワークスペース。",
    ogImageTitle: "参考文献スタジオ",
    ogImageSubtitle: "参考文献を整理、注釈、再整形、書き出し、共有。",
    ogKind: "引用ワークスペース",
    breadcrumb: "参考文献スタジオ",
    eyebrow: "ブラウザー内の非公開ワークスペース",
    lead: "論文の参考文献を一か所で管理できます。書き出しや共有を選ばない限り、プロジェクトはこのブラウザー内に保存されます。",
    privacyTitle: "初期設定で非公開",
    privacyBody:
      "プロジェクトと注釈はブラウザーのローカル保存領域を使用します。共有リンクには引用が含まれますが、非公開のメモは意図的に除外されます。",
    workflowTitle: "資料リストから完成原稿まで",
    workflowBody:
      "プロジェクトの切り替え、文献の検索と並べ替え、注釈やページ位置の追加、メタデータの修正、リスト全体のスタイル統一ができます。",
    formatsTitle: "文献を読み込み、どこへでも書き出し",
    formatsBody:
      "BibTeX、RIS、CSL-JSONを読み込めます。整形済みリストをコピーするか、Word、RTF、RIS、CSL-JSON、HTML、BibTeX、注釈版を書き出せます。",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term}－定義と例",
    notFoundTitle: "用語が見つかりません",
    keywordDefinition: "{term} 定義",
    keywordWhatIs: "{term} とは",
    ogTitle: "{term}－CitationEasy用語集",
    ogKind: "引用用語集",
    breadcrumb: "用語集",
    alsoCalled: "別名：{aliases}",
    doItHeading: "CitationEasyで試す",
    seeAlsoHeading: "関連項目",
    moreInHeading: "{category}の他の用語",
    navLabel: "用語集ナビゲーション",
    allTermsLink: "全 {count} 件の用語集を見る",
    generatorLink: "無料の引用ジェネレーター",
    termSetName: "CitationEasy 引用用語集",
    hubMetaTitle: "引用用語集－{count} 件の用語を解説",
    hubMetaDescription:
      "et al.、ibid.、DOI、ぶら下げインデント、パッチライティング、公式版など、{count} 件の引用・学術ライティング用語を、それぞれ例とともに平易な言葉で解説します。",
    hubKeyword1: "引用用語集",
    hubKeyword2: "引用 用語",
    hubKeyword3: "学術ライティング用語集",
    hubKeyword4: "et al とは",
    hubKeyword5: "DOI とは",
    hubKeyword6: "引用用語",
    hubOgTitle: "引用用語集",
    hubOgDescription:
      "{count} 件の引用・学術ライティング用語を、例とともに解説します。",
    hubOgImageTitle: "引用用語集",
    hubOgImageSubtitle:
      "{count} 件の引用・学術ライティング用語を、例とともに平易な言葉で解説します。",
    hubOgKind: "リファレンス",
    hubTermSetDescription:
      "{count} 件の引用・参考文献・学術ライティング用語の定義です。",
    hubCollectionName: "引用用語集",
    hubCollectionDescription:
      "{count} 件の引用・学術ライティング用語を、平易な言葉で解説します。",
    hubHeading: "引用用語集",
    hubIntro:
      "引用と学術ライティングに関する {count} 件の用語を、例とともに平易な言葉で解説します。スタイルガイドに登場する略語、参考文献を構成する各要素、資料を特定するための識別子、そして学術出版の用語を網羅しています。",
    hubJumpLabel: "頭文字で移動",
    hubBrowseHeading: "テーマ別に見る",
    hubAllHeading: "全用語（アルファベット順）",
    hubWorkHeading: "用語を実際に使ってみる",
    hubWorkGenerator: "無料の引用ジェネレーター",
    hubWorkStyles: "引用スタイルガイド",
    hubWorkHowTo: "あらゆる資料の引用方法",
    hubWorkCompare: "引用スタイルを比較",
    hubWorkTools: "ライティング・引用ツール",
    hubWorkFaq: "引用に関するFAQ",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle: "引用に関するFAQ－よくある質問へのすぐわかる回答",
    metaDescription:
      "DOI、著者不明の資料、et al.、ぶら下げインデント、AIの引用、盗用のルール、APAとMLAの違いなど、学生が実際に抱く引用の疑問にすばやく正確に回答します。詳しいガイドへのリンク付き。",
    ogTitle: "引用に関するFAQ",
    ogDescription:
      "DOI や et al. から ChatGPT の引用まで、よくある引用の疑問にすばやく回答します。",
    ogImageTitle: "引用に関する質問と回答",
    ogImageSubtitle: "学生が実際に抱く引用の疑問に、短く正確に答えます。",
    ogKind: "FAQ",
    breadcrumbLabel: "パンくずリスト",
    breadcrumbHome: "ホーム",
    breadcrumbCurrent: "引用に関するFAQ",
    heading: "引用に関するFAQ",
    intro:
      "学生が実際に抱く引用の疑問に、すばやく正確に回答します。より詳しく知りたいときは、各ガイドやツールへのリンクをご利用ください。",
    contentsLabel: "FAQの目次",
    stillStuckHeading: "まだ解決しませんか？",
    stillStuckBody:
      "[ガイド一覧](/guides) を見る、[スタイル別チートシート](/cheat-sheets) を確認する、[引用用語集](/glossary) で用語を調べる、[サイト全体を検索する](/search)、あるいはそのまま [引用を作成](/) してジェネレーターにルールを適用させることもできます。",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "引用スタイルチートシート－クイックリファレンスガイド",
    hubMetaDescription:
      "APA・MLA・シカゴの引用スタイルのクイックリファレンスチートシートです。よくある資料タイプの例付きで、印刷にも適しています。",
    hubBreadcrumbHome: "ホーム",
    hubBreadcrumbCurrent: "引用スタイルチートシート",
    hubBackLink: "← ジェネレーターに戻る",
    hubHeading: "引用スタイルチートシート",
    hubIntro:
      "人気の引用スタイルのクイックリファレンスガイドです。印刷にも適しており、常に最新の内容です。",
    hubApaTitle: "APA 第7版チートシート",
    hubApaDesc: "心理学、社会科学、教育学、看護学",
    hubMlaTitle: "MLA 第9版チートシート",
    hubMlaDesc: "文学、語学、人文学、文化研究",
    hubChicagoTitle: "シカゴスタイルチートシート",
    hubChicagoDesc: "歴史学、美術史、哲学、宗教学",
    backToSheets: "← チートシート一覧に戻る",
    generalRules: "基本ルール",
    inTextCitations: "文中引用",
    colSituation: "状況",
    colFormat: "形式",
    colExample: "例",
    book: "書籍",
    journalArticle: "学術論文",
    website: "ウェブサイト",
    apaMetaTitle: "APA 第7版チートシート－クイックリファレンスガイド",
    apaMetaDescription:
      "書籍・論文・ウェブサイトなどの例を含む APA 第7版の引用チートシートです。印刷に適したクイックリファレンス。",
    apaHeading: "APA 第7版チートシート",
    apaLead: "よく使われる APA 引用形式のクイックリファレンスです。",
    apaRule1:
      "**ぶら下げインデント**を使用する（1行目は左端に揃え、2行目以降は 0.5 インチ字下げする）",
    apaRule2: "すべての項目をダブルスペースにする",
    apaRule3: "著者の姓のアルファベット順に並べる",
    apaRule4: "書籍・雑誌・巻号のタイトルは斜体にする",
    apaRule5: "DOI が利用可能な場合は使用する",
    apaRow1Situation: "著者1名",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "著者2名",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "著者3名以上",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "直接引用",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "著者不明",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "参考文献リストの例",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "編著書の章",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "会議論文",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "APA第6版からの主な変更点",
    apaDifference1: "URL の前に「Retrieved from」を付けない",
    apaDifference2: "DOI は https://doi.org/ 形式のリンクとして記載する",
    apaDifference3: "著者は最大20名まで列挙してから省略記号を使う",
    apaDifference4: "出版社の所在地の記載は不要になった",
    apaDifference5: 'ジェンダーニュートラルな表現には単数形の "they" を使う',
    apaCtaText: "APA の引用を自動で正確に作成",
    apaCtaButton: "APA 引用ジェネレーター →",
    mlaMetaTitle: "MLA 第9版チートシート－クイックリファレンスガイド",
    mlaMetaDescription:
      "書籍・論文・ウェブサイトなどの例を含む MLA 第9版の引用チートシートです。印刷に適したクイックリファレンス。",
    mlaHeading: "MLA 第9版チートシート",
    mlaLead: "よく使われる MLA 引用形式のクイックリファレンスです。",
    mlaRule1: "**ぶら下げインデント**を使用する",
    mlaRule2: "すべての項目をダブルスペースにする",
    mlaRule3: "著者の姓のアルファベット順に並べる",
    mlaRule4: "ページのタイトルを「引用文献一覧」にする",
    mlaRule5: "コンテナ（書籍・雑誌・ウェブサイト）のタイトルは斜体にする",
    mlaRow1Situation: "著者1名",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "著者2名",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "著者3名以上",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "著者不明",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "ページ番号なし",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "引用文献一覧の例",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "アンソロジー・編著書",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "MLAのコア要素（記載順）",
    mlaCore1: "Author.",
    mlaCore2: '"Title of Source."',
    mlaCore3: "*Title of Container*,",
    mlaCore4: "Contributors,",
    mlaCore5: "Version,",
    mlaCore6: "Number,",
    mlaCore7: "Publisher,",
    mlaCore8: "Publication date,",
    mlaCore9: "Location (pages, URL, DOI).",
    mlaCtaText: "MLA の引用を自動で正確に作成",
    mlaCtaButton: "MLA 引用ジェネレーター →",
    chicagoMetaTitle: "シカゴスタイルチートシート－クイックリファレンスガイド",
    chicagoMetaDescription:
      "注・文献目録形式と著者・年形式の例を含む、シカゴマニュアルオブスタイルの引用チートシートです。印刷に適したクイックリファレンス。",
    chicagoHeading: "シカゴスタイルチートシート",
    chicagoLead:
      "シカゴマニュアルオブスタイル（第18版）の引用形式のクイックリファレンスです。",
    chicagoSystemsHeading: "シカゴの2つの方式",
    chicagoColNb: "注・文献目録方式（NB）",
    chicagoColAd: "著者・年方式（AD）",
    chicagoRow1Nb: "脚注・後注＋文献目録",
    chicagoRow1Ad: "括弧内引用＋参考文献リスト",
    chicagoRow2Nb: "歴史学・芸術・人文学",
    chicagoRow2Ad: "科学・社会科学",
    chicagoRow3Nb: "初出の注はより詳細",
    chicagoRow3Ad: "APA形式に近い",
    chicagoExamplesHeading: "注・文献目録形式の例",
    chicagoNoteLabel: "注：",
    chicagoBibliographyLabel: "文献目録：",
    chicagoBookLabel: "書籍（脚注）",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "学術論文（脚注）",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "ウェブサイト（脚注）",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "短縮注",
    chicagoShortIntro: "最初の完全な引用の後は、短縮した脚注を使用します：",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "主な書式ルール",
    chicagoRule1: "本文中の脚注参照には上付き数字を使用する",
    chicagoRule2: "文献目録の項目にはぶら下げインデントを使用する",
    chicagoRule3:
      "同じ資料を続けて引用する場合も「Ibid.」ではなく短縮した脚注を使う",
    chicagoRule4: "タイトル：書籍・雑誌は斜体、論文・章の題は引用符で囲む",
    chicagoRule5:
      "内容が変わる可能性のあるオンライン資料には、アクセス日を記載する",
    chicagoCtaText: "シカゴスタイルの引用を自動で正確に作成",
    chicagoCtaButton: "シカゴ引用ジェネレーター →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "主要ページ",
    styleLanding: "主要な引用スタイルのハブ",
    style: "引用スタイルのリファレンスページ",
    styleExamples: "引用例のページ",
    styleFormat: "論文の書式ガイド",
    styleInText: "文中引用のガイド",
    styleAnnotatedBibliography: "注釈付き参考文献リストのガイド",
    styleReferencePage: "参考文献・引用文献一覧ページのガイド",
    tool: "無料のライティング・引用ツール",
    guide: "学習ガイド",
    guideCategory: "ガイドのカテゴリ",
    toolCollection: "ツールコレクション",
    howToCite: "<style>における<source>の引用方法",
    comparison: "引用スタイルの比較",
    converter: "識別子・書式の変換ツール",
    field: "学問分野別の引用スタイル",
    region: "国・地域別の引用スタイル",
    category: "主題別の引用スタイル",
    cheatSheet: "1 ページのチートシート",
    glossary: "引用と学術ライティングの用語集",
  },

  // /about
  aboutPage: {
    metaTitle: "CitationEasyについて－無料の引用ジェネレーター",
    metaDescription:
      "CitationEasyは{count}種類のスタイルに対応した無料の引用ジェネレーターです。Citation Style Language、Citation.js、Next.js などのオープンソースツールを使い、Samuel Sergi が開発しました。",
    backLink: "← ジェネレーターに戻る",
    heading: "CitationEasyについて",
    intro:
      "CitationEasyは、学生・研究者・学術ライターのために作られた、無料でオープンな引用ジェネレーターです。**{count} 種類の引用スタイル**に対応し、登録や購読なしで、ライティングツール・学習ガイド・参考資料を続々と追加しています。",
    offerHeading: "提供内容",
    offer1:
      "APA 第7版、MLA 第9版、シカゴ第18版、ハーバード、バンクーバー、IEEE など {count} 種類のスタイルに対応した [引用ジェネレーター](/)",
    offer2:
      "単語数カウンター、読みやすさ判定、DOI 検証ツール、文献リストのアルファベット順整列など、[無料のライティング・引用ツール 40 種類](/tools)",
    offer3:
      "6 つの引用スタイルにわたり、主要な資料タイプを網羅する [引用方法ガイド 750 件](/how-to-cite)",
    offer4:
      "引用のベストプラクティス、学術ライティング、リサーチスキルに関する [学習ガイド 100 件以上](/guides)",
    offer5:
      "手軽に参照できる [スタイル比較ツール](/compare)、[引用スタイル診断](/quiz)、[チートシート](/cheat-sheets)",
    offer6:
      "プレーンテキスト、BibTeX、Word、番号付きリスト、箇条書きリスト、RIS、CSV の 7 種類の書き出し形式",
    openSourceHeading: "オープンソースで構築",
    openSourceIntro:
      "CitationEasyは、数多くの優れたオープンソースプロジェクトと API によって成り立っています。使わせていただいているものには、きちんと謝辞を述べたいと思います。",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) － 私たちの {count} 種類の引用スタイルを支えるオープンな標準規格です。CSL はボランティアのコミュニティによって保守されており、Zotero、Mendeley、Papers などの文献管理ツールでも使われています。スタイル定義は GitHub の [CSL Styles Repository](https://github.com/citation-style-language/styles) から取得しています。",
    openSource2:
      "[Citation.js](https://citation.js.org/) － 引用を処理し、CSL スタイルに従って整形する JavaScript ライブラリです。Lars Willighagen 氏が開発しました。",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) － Internet Archive が提供する無料の書籍検索 API で、書名や ISBN から書籍のメタデータを調べる際に使用しています。",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) － DOI の解決と検証に使用している Digital Object Identifier システムです。",
    createdHeading: "開発者について",
    createdBody:
      "CitationEasyは **Samuel Sergi** が開発・運営しています。目的はシンプルです。機能を有料プランの向こうに隠したり、アカウント登録を求めたりしない、本当に無料で質の高い引用ツールを提供することです。",
    contactPrompt:
      "ご質問・ご意見・ご提案がありましたら、お気軽にご連絡ください。",
    contactEmail: "メール：[sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "私たちの使命",
    mission1:
      "正確な引用にお金がかかるべきではありません。多くの引用ツールは無料をうたいながら、書き出し形式を制限したり、引用の件数を制限したり、有料プランへの加入を促したりします。CitationEasyは、完全無料であることにこだわっています。登録不要、制限なし、有料プランなしです。",
    mission2:
      "引用ジェネレーターからライティングツール、学習ガイドまで、このサイトのすべての機能は誰でも無料で利用できます。学問的誠実性を支えるツールは、予算にかかわらず、すべての学生・研究者が利用できるべきだと私たちは考えています。",
  },

  // /contact
  contactPage: {
    metaTitle: "お問い合わせ",
    metaDescription:
      "CitationEasyへのお問い合わせはこちらから。無料の引用ジェネレーターやライティングツールについて、ご質問・ご意見・ご提案をお待ちしています。",
    backLink: "← ジェネレーターに戻る",
    heading: "お問い合わせ",
    intro:
      "CitationEasyについてご質問・ご意見・ご提案がありますか？ぜひお聞かせください。不具合を見つけた、機能のご要望がある、引用についてサポートが必要など、どんな内容でもお気軽にご連絡ください。",
    touchHeading: "ご連絡方法",
    touchBody:
      "お問い合わせはメールが最も確実です。48 時間以内の返信を心がけています。",
    emailLine: "**メール：** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "よくあるご質問",
    commonIntro:
      "ご連絡いただく前に、以下のリソースで答えが見つかることがあります。",
    resource1:
      "[引用ガイド](/guides) － 主要なスタイルごとに、資料を引用する手順をステップごとに解説",
    resource2:
      "[引用方法ガイド](/how-to-cite) － 資料タイプとスタイルの 750 通りの組み合わせを、例とともに紹介",
    resource3:
      "[チートシート](/cheat-sheets) － APA・MLA・シカゴの書式をすばやく確認できる一覧",
    resource4:
      "[ライティングツール](/tools) － 単語数カウンター、読みやすさ判定、DOI 検証ツールなど",
    issueHeading: "不具合の報告",
    issueIntro:
      "引用の書式の誤り、機能の不具合、スタイルの間違いなどを見つけた場合は、ご連絡の際に次の情報をできるだけ詳しくお知らせください。",
    issue1: "使用していた引用スタイル",
    issue2: "資料の種類（書籍、ウェブサイト、学術論文など）",
    issue3: "期待していた結果と実際に生成された結果の違い",
    issue4: "使用しているブラウザーとデバイス（関係がある場合）",
    issueOutro: "この情報により、問題の特定と修正を迅速に行えます。",
    aboutHeading: "CitationEasyについて",
    aboutBody:
      "CitationEasyは、10,000 種類を超える引用スタイルに対応した無料の引用ジェネレーターです。正確な引用を誰もが利用できるようにという目的のもと、Samuel Sergi によって開発されました。詳しくは [CitationEasyについて](/about) のページをご覧ください。",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "AIアシスタント・エージェント向けCitationEasy－API、MCPサーバー、llms.txt",
    metaDescription:
      "CitationEasyをプログラムから利用できます。{count} 種類のスタイルに対応した無料の認証不要 JSON API、エージェント向け MCP サーバー、llms.txt、OpenAPI 仕様、そしてすべてのページの Markdown ビューを提供しています。",
    keyword1: "引用 API",
    keyword2: "MCP サーバー",
    keyword3: "引用ジェネレーター API",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "AI エージェント 引用",
    keyword7: "無料 引用 API",
    webApiDescription:
      "URL・DOI・ISBN・PubMed ID・arXiv ID、または CSL-JSON メタデータから、{count} 種類の Citation Style Language スタイルで引用を整形する、無料で認証不要の JSON API です。",
    breadcrumb: "AI・エージェント向け",
    heading: "AIアシスタント・エージェント向けCitationEasy",
    intro:
      "このサイトのすべては、人だけでなくソフトウェアからも利用できます。無料の JSON API、MCP サーバー、OpenAPI 仕様、llms.txt インデックス、そして全 {count} ページの Markdown ビューを提供しています。キーもアカウントも不要で、当サイト独自のレート制限もありません。",
    whyHeading: "引用を自分で書かず API を呼ぶべき理由",
    whyBody:
      "引用の書式整形は、一見テキスト生成の問題のように見えますが、実際は違います。それぞれのスタイルには、著者名の反転・イニシャル表記・タイトルケース・コンテナの句読点・版表記・日付の位置など、数百ものルールが定められており、しかもスタイルごとに微妙に異なるため、記憶を頼りに書くと簡単に間違えてしまいます。CitationEasy は、公式の Citation Style Language 定義に対して **citeproc-js** を実行します。これは Zotero や Mendeley と同じエンジンであり、出力は決定的で、学術誌の投稿システムが期待する形式と一致します。メタデータは Crossref・Open Library・PubMed から取得しており、何かを創作することはありません。データ元に存在しない項目は、もっともらしい推測で埋めるのではなく、欠落したままになります。",
    generateHeading: "引用を作成する",
    generateBody:
      "1 回の呼び出しで最大 10 件の資料を処理するには、`input` の代わりに `inputs` を送信してください。すでに CSL-JSON メタデータを持っている場合は、`entry` を使えば検索を完全に省略できます。脚注形式が必要な場合は `note: true` を追加してください。資料ごとのエラーはその資料に対して返されるため、一括処理全体が失敗することはありません。",
    mcpHeading: "MCP で接続する",
    mcpIntro:
      "`/api/mcp` にある Model Context Protocol エンドポイントは、ストリーム対応 HTTP 上で JSON-RPC 2.0 を話し、認証情報は不要です。",
    mcpToolsHeading: "提供されるツール",
    endpointsHeading: "エンドポイント",
    colEndpoint: "エンドポイント",
    colWhat: "できること",
    endpointCite:
      "最大 10 件の資料を一度に整形します。URL・DOI・ISBN・PubMed ID・arXiv ID・BibTeX/RIS/CSL-JSON テキスト、または CSL-JSON エントリーオブジェクトを受け付けます。参考文献の項目に加え、必要に応じて文中引用や脚注も返します。",
    endpointStyles:
      "名前・引用書式クラス・分野・地域で、{count} 種類すべてのスタイルを検索します。",
    endpointStyleSlug:
      "1 つのスタイルの詳細を、その CSL 定義自身から生成した実際の整形例とともに返します。",
    endpointSearch:
      "サイト内のすべてのページを対象にした、関連度順の検索です。",
    endpointPages:
      "サイトカタログ全体を構造化されたエントリーとして返します。ページタイプで絞り込めます。",
    endpointHowToCite:
      "資料タイプ × スタイルごとのすべてのガイドページで、どちらでも絞り込めます。",
    endpointTools:
      "すべての無料ツールを、カテゴリーとキーワードとともに返します。",
    endpointGuides: "すべての学習ガイドを、カテゴリーとともに返します。",
    endpointConverters: "サイトが提供するすべての識別子・書式変換を返します。",
    endpointComparisons:
      "両方のスタイルのレコードにリンクした、並列のスタイル比較です。",
    endpointFields:
      "「どのスタイルを使うべきか」という問いに答えるための、学問分野・主題カテゴリー・地域です。",
    endpointFaq:
      "よくある引用の質問に対する、検証済みの回答です。q で絞り込めます。",
    endpointGlossary:
      "引用・学術ライティング用語とその完全な定義です。レスポンス自体にテキストが含まれるため、後から別ページを取得する必要はありません。",
    endpointIndex:
      "エンドポイントの発見用ドキュメントです。まず探索を始めるならここから。",
    discoveryHeading: "発見用ファイル",
    discoveryLlms: "言語モデル向けに書かれた、サイトの厳選インデックスです。",
    discoveryLlmsFull:
      "サイトが公開するすべてのページを、タイプ別に1行ずつまとめたものです。",
    discoveryOpenapi: "公開 API 全体の OpenAPI 3.1 記述です。",
    discoveryMcp:
      "MCP エンドポイント（ストリーム対応 HTTP）です。ブラウザーで GET すると説明が表示されます。",
    discoveryWellKnownMcp:
      "ドメインを探索するエージェント向けの MCP 発見用ドキュメントです。",
    discoveryAiPlugin:
      "従来型のプラグインを探すフレームワーク向けの、レガシーなプラグインマニフェストです。",
    discoveryMd: "サイト上のあらゆるページの Markdown ビューです。",
    discoverySitemap: "インデックス可能なすべての URL です。",
    catalogHeading: "カタログの内容",
    catalogIntro:
      "以下のすべてのページは、HTML として、`/md/` 以下の Markdown として、そして `/api/v1/pages` からの構造化エントリーとして取得できます。",
    catalogStyles:
      "**{count}** 種類の引用スタイル。それぞれ自身の CSL 定義から生成された実際の例付きです。",
    catalogTools: "**{count}** 種類の無料ブラウザーツール",
    catalogGuides: "**{count}** 件の学習ガイド",
    catalogHowToCite: "**{count}** 件の引用方法ページ",
    catalogComparisons: "**{count}** 件のスタイル比較",
    catalogConverters: "**{count}** 件の変換ツール",
    catalogFields: "**{count}** の学問分野",
    catalogStyleLandings:
      "完全な書式ルールを備えた **{count}** の主要スタイルハブ",
    faqHeading: "よくある質問",
    faqFreeQ: "CitationEasy の API は無料ですか？API キーは必要ですか？",
    faqFreeA:
      "無料で、API キーも不要です。/api/v1 以下のすべてのエンドポイントは認証不要かつ CORS オープンなので、登録なしでブラウザー・ノートブック・エージェントから呼び出せます。当サイト独自のレート制限はありませんが、識別子の検索は Crossref・Open Library・PubMed にプロキシされており、それぞれが独自の公正利用制限を設けています。多数の並列リクエストを送るのではなく、`inputs` を使って一括処理してください。",
    faqLlmQ: "引用は言語モデルによって生成されているのですか？",
    faqLlmA:
      "いいえ。書式整形は、参考文献管理ソフトと同じエンジンである citeproc-js を、公式の Citation Style Language 定義に対して実行することで行われます。同じ入力とスタイルからは、常に同じ文字列が生成されます。書誌メタデータは Crossref（DOI）、Open Library（ISBN）、PubMed（PMID）から取得しています。CitationEasy は項目を創作することはないため、データ元に存在しない情報は、推測されることなく出力にも欠落したままとなります。",
    faqMcpQ:
      "エージェントを MCP 経由で CitationEasy に接続するにはどうすればよいですか？",
    faqMcpA:
      "任意の Model Context Protocol クライアントで、ストリーム対応 HTTP トランスポートを使い https://www.citationeasy.com/api/mcp を指定してください。認証情報は不要です。Claude Code の場合：`claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`。このサーバーは、引用の生成、{count} 種類のスタイルの検索、資料タイプ別ガイダンス、サイト内検索、そしてどのページも Markdown として読み取るためのツールを公開しています。",
    faqStylesQ: "この API はどの引用スタイルに対応していますか？",
    faqStylesA:
      "Citation Style Language リポジトリにある {count} 種類すべてのスタイルに対応しています。APA 7・MLA 9・シカゴの両方式・ハーバード・バンクーバー・IEEE・AMA、そして数千の個別学術誌スタイルも含まれます。`style` フィールドにスタイルのスラッグを指定してください。「chicago」や「harvard」のようなわかりやすいスラッグは正しい CSL バリアントに解決され、それ以外は /api/v1/styles?q= で検索できます。",
    faqLlmsTxtQ:
      "llms.txt とは何ですか？CitationEasy のものはどこにありますか？",
    faqLlmsTxtA:
      "llms.txt は、ブラウザーではなく言語モデル向けに書かれた、サイトのプレーンテキストインデックスです。CitationEasy のものは /llms.txt にあり、サイトのすべてのページを網羅した完全版は /llms-full.txt にあります。",
    faqMarkdownQ:
      "CitationEasy のページを HTML ではなく Markdown として読めますか？",
    faqMarkdownA:
      "はい。サイト内のどのパスにも /md/ を前に付けてください。例えば /md/citation-style/apa や /md/tools/word-counter です。データ駆動型のページは、各スタイル自身の CSL 定義から生成された実際の整形例を含む、全内容を返します。手書きの文章ページ（ガイドやチートシートなど）は、本文がページ自体にあるため、要約カードと正規の HTML の URL を返します。",
    faqReuseQ: "CitationEasy の出力を自分の製品で使ってもよいですか？",
    faqReuseA:
      "はい。整形された引用は資料に関する事実であり、自由にお使いいただけます。CSL のスタイル定義自体は、Citation Style Language プロジェクトが CC BY-SA 3.0 のもとで提供しています。CitationEasy へのクレジット表記は歓迎しますが、必須ではありません。",
    missingHeading: "何か足りないものはありますか？",
    missingBody:
      "エージェントに必要なエンドポイント・フィールド・形式がここにない場合は、[お知らせください](/contact)。手動で閲覧される場合は、[引用ジェネレーターから始めてください](/)。",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "どの引用スタイルを使うべき？－無料スタイル診断",
    metaDescription:
      "分野・論文の種類・好みについていくつかの質問に答えるだけで、あなたの論文に最適な引用スタイルがわかります。APA、MLA、シカゴ、バンクーバーなど。",
    ogTitle: "どの引用スタイルを使うべき？",
    ogDescription:
      "無料の診断で、あなたの論文に最適な引用スタイルを見つけましょう。",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "スタイル診断",
    backLink: "← ジェネレーターに戻る",
    heading: "どの引用スタイルを使うべき？",
    intro:
      "いくつかの簡単な質問に答えると、あなたの論文に最適な引用スタイルをおすすめします。",
    progress: "質問 {current} / {total}",
    qDiscipline: "専攻分野は何ですか？",
    optSocialScience: "心理学・社会科学",
    optHumanities: "文学・人文学",
    optHistory: "歴史学・美術史",
    optMedical: "医学・看護学・保健学",
    optEngineering: "工学・情報科学",
    optNaturalScience: "自然科学（生物学・化学）",
    optLaw: "法学",
    optBusiness: "経営学・経済学",
    qPaperType: "どのような論文を書いていますか？",
    optResearch: "研究論文・学位論文",
    optReview: "文献レビュー",
    optReport: "実験レポート・技術レポート",
    optEssay: "エッセイ・授業課題",
    optJournal: "学術雑誌への投稿論文",
    qRegion: "所属機関はどこにありますか？",
    optUs: "アメリカ合衆国",
    optUk: "イギリス・オーストラリア",
    optCanada: "カナダ",
    optEurope: "ヨーロッパ（イギリスを除く）",
    optOther: "その他",
    qPreference: "引用形式に希望はありますか？",
    optAuthorDate: "文中引用（著者名、発行年）",
    optNumeric: "番号付き参考文献 [1]",
    optFootnotes: "脚注",
    optNoPreference: "特にない",
    styleVancouver: "バンクーバー",
    styleAma: "AMA（アメリカ医師会）",
    styleIeee: "IEEE",
    styleBluebook: "ブルーブック",
    styleCse: "CSE（科学編集者評議会）",
    styleChicagoNotes: "シカゴ（注釈・文献目録形式）",
    styleMla: "MLA（第9版）",
    styleApa: "APA（第7版）",
    styleHarvard: "ハーバード",
    reasonVancouverMedical:
      "バンクーバー方式は、医学・保健科学系の学術誌における標準スタイルで、番号付きの参考文献を使用します。",
    reasonAma:
      "AMA は医学系の学術誌で広く使われており、番号付きの引用を用います。",
    reasonIeee: "IEEE は、工学・情報科学・IT 分野の標準的な引用スタイルです。",
    reasonBluebook:
      "ブルーブックは、法律文書における決定的な引用スタイルです。シカゴスタイルが、それに最も近い汎用的な代替スタイルです。",
    reasonCse: "CSE は、生物学・自然科学分野の標準スタイルです。",
    reasonChicagoHistory:
      "シカゴ（注釈・文献目録形式）は、歴史学・美術史分野の定番スタイルで、脚注を用いて引用します。",
    reasonChicagoHumanities:
      "シカゴ（注釈・文献目録形式）は、脚注を用いる方式のため、人文学分野に適しています。",
    reasonMla: "MLA は、文学・語学・人文学分野の標準スタイルです。",
    reasonApaBusiness:
      "APA は、経営学・経済学・マネジメント分野で広く使われています。",
    reasonHarvard:
      "ハーバード方式は、イギリスやオーストラリアの大学で最も一般的なスタイルです。",
    reasonChicagoFootnotes:
      "シカゴ（注釈・文献目録形式）は脚注を用いるため、詳細な引用に適しています。",
    reasonVancouverNumeric:
      "バンクーバー方式は番号付きの引用を用いるため、本文をすっきりと読みやすく保てます。",
    reasonApaDefault:
      "APA は、社会科学・教育学をはじめ、多くの分野で最も広く使われている引用スタイルです。",
    recommendLabel: "おすすめのスタイル",
    generateButton: "{style} で引用を作成",
    retakeButton: "もう一度診断する",
    guidesLink: "さらに詳しく知りたい方は引用ガイドをご覧ください →",
    previousButton: "← 前の質問",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "CitationEasy を検索",
    metaDescription:
      "CitationEasy のすべてのページを一度に検索：{count} 種類の引用スタイル、250 以上の無料ツール、ガイド、引用方法ページ、スタイル比較、変換ツール、用語集。",
    keyword1: "引用スタイル 検索",
    keyword2: "引用ガイド 検索",
    keyword3: "引用ツール 検索",
    ogDescription:
      "サイト内のすべてのページを一度に検索できます。スタイル、ツール、ガイド、引用方法ページ、比較、変換ツール、用語集の用語まで。",
    ogImageSubtitle:
      "すべての引用スタイル・ツール・ガイド・引用方法ページ・比較・変換ツール・用語集の用語を、まとめて検索できます。",
    ogKind: "検索",
    breadcrumb: "検索",
    heading: "CitationEasy を検索",
    intro:
      "サイト内のすべての引用スタイル・ツール・ガイド・引用方法ページ・比較・変換ツール・用語集の用語を、まとめて検索できます。",
    inputLabel: "検索キーワード",
    inputPlaceholder:
      "例：ポッドキャストを APA で引用、ぶら下げインデント、DOI",
    submit: "検索",
    browseHeading: "またはセクションから探す",
    browseStyles: "引用スタイル",
    browseStylesNote: "{count} 種類のスタイル",
    browseTools: "無料ツール",
    browseToolsNote: "{count} 種類のツール",
    browseHowTo: "あらゆる資料の引用方法",
    browseHowToNote: "{count} ページ",
    browseGuides: "ガイド",
    browseGuidesNote: "{count} 件のガイド",
    browseGlossary: "用語集",
    browseGlossaryNote: "{count} 件の用語",
    browseComparisons: "スタイル比較",
    browseComparisonsNote: "{count} 件の比較",
    browseConverters: "変換ツール",
    browseConvertersNote: "{count} 件の変換ツール",
    browseCheatSheets: "チートシート",
    browseCheatSheetsNote: "{count} 件のシート",
    facetsLabel: "ページタイプで絞り込む",
    facetAll: "すべて（{count}）",
    noMatches: "「{query}」に一致するページはありません。",
    matchesOne: "「{query}」に一致するページが {count} 件見つかりました。",
    matchesMany: "「{query}」に一致するページが {count} 件見つかりました。",
    pagerLabel: "結果のページ",
    pagerPrevious: "← 前へ",
    pagerNext: "次へ →",
    pagerPosition: "{total} ページ中 {page} ページ目",
    paletteLoading: "検索中…",
    paletteError: "現在、検索を利用できません。もう一度お試しください。",
    paletteViewAll: "「{query}」のすべての結果を見る",
    apiNote:
      "開発をされている方へ：同じインデックスは [/api/v1/search](/api/v1/search?q=podcast) から JSON でも、MCP 経由でも利用できます。詳しくは [エージェント向けドキュメント](/ai) をご覧ください。",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "このページを引用－ワンクリック引用（ブックマークレット＆Chrome拡張機能）",
    metaDescription:
      "どんなウェブページもワンクリックで引用できます。無料の「このページを引用」ブックマークレットをブックマークバーにドラッグするか、ツールバーボタンと右クリック引用機能を備えた無料の Chrome 拡張機能をインストールしてください。Chromebook や制限のかかったブラウザーでも使えます。",
    ogTitle: "このページを引用 ブックマークレット＆Chrome拡張機能",
    ogDescription:
      "どんなページからでもワンクリックでウェブサイトを引用できます。ドラッグ＆ドロップのブックマークレットと、右クリック引用に対応した無料の Chrome 拡張機能です。",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "このページを引用 ブックマークレット",
    appName: "このページを引用 ブックマークレット",
    appDescription:
      "今読んでいるウェブページをワンクリックで引用できる無料のブックマークレットです。そのページの URL があらかじめ入力された状態で CitationEasy を開き、APA・MLA・シカゴなど {count} 種類以上のスタイルで引用を整形します。",
    breadcrumbLabel: "パンくずリスト",
    breadcrumbHome: "ホーム",
    breadcrumbCurrent: "このページを引用 ブックマークレット",
    heading: "このページを引用：ブックマークレット＆Chrome拡張機能",
    intro:
      "どんなウェブページもワンクリックで引用できます。登録は不要です。下のブックマークレットをブックマークバーにドラッグするだけ（インストール不要）、あるいはツールバーボタンと右クリック引用に対応した無料の Chrome 拡張機能をご利用ください。",
    dragPrompt: "このボタンをブックマークバーにドラッグしてください：",
    buttonTitle: "ブックマークバーにドラッグしてください",
    buttonLabel: "📑 このページを引用",
    dontClick:
      "ここではクリックしないでください。まずブックマークバーにドラッグしてください。",
    installHeading: "インストール方法",
    step1Title: "ブックマークバーを表示する",
    step1Body:
      "ほとんどのブラウザーでは Ctrl+Shift+B（Mac では Cmd+Shift+B）を押すとブックマークバーの表示・非表示を切り替えられます。ボタンをドロップする場所を確保しましょう。",
    step2Title: "ボタンを上にドラッグする",
    step2Body:
      "下にある「このページを引用」ボタンをクリックしたまま、ブックマークバーまでドラッグして離してください。通常のブックマークとして登録されます。",
    step3Title: "どのページでもクリックする",
    step3Body:
      "記事・ニュース・論文ページなどを読んでいるときに、新しく追加したブックマークをクリックしてください。そのページの URL があらかじめ入力された状態で CitationEasy が開き、すぐにコピーできる引用が用意されます。",
    manualHeading: "ドラッグできない場合は、手動で追加してください",
    manualBody:
      "新しいブックマークを作成し、名前を「このページを引用」として、次の内容を URL / アドレスとして貼り付けてください。",
    howHeading: "仕組み",
    howBody:
      "このブックマークレットは、あなたが読んでいるページ上でコードを実行することはありません。そのページの URL を CitationEasy に渡すだけで、当サイトのサーバーが公開されているページのメタデータを取得・解析します。これは、URL を手動でジェネレーターに貼り付けたときと同じ、信頼できる方法です。この仕組みにより安全性が保たれ、旧来のページ内ブックマークレットを使えなくしたクロスオリジンの制限も回避できます。",
    extensionHeading: "Chrome 拡張機能をお好みですか？",
    extensionBody:
      "無料の CitationEasy 拡張機能を使うと、現在のタブを引用できるツールバーボタンに加え、開かなくてもリンクや選択した DOI・ISBN を引用できる右クリックメニューが追加されます。ブックマークレットと同様、訪問したページ上でコードを実行することはなく、URL を CitationEasy に渡すだけです。必要な権限は `activeTab` と `contextMenus` のみで、Chrome・Edge・Brave など Chromium 系のブラウザーで動作します。",
    downloadButton: "⬇ Chrome 拡張機能をダウンロード（.zip）",
    install1: "拡張機能をダウンロードして解凍してください。",
    install2:
      "`chrome://extensions` を開き、右上の **デベロッパー モード** をオンにしてください。",
    install3:
      "**パッケージ化されていない拡張機能を読み込む** をクリックし、解凍したフォルダーを選択してください。",
    install4:
      "CitationEasy のボタンをピン留めし、どのページでもクリックして引用してください。",
    faqHeading: "よくある質問",
    faqWhatQ: "「このページを引用」ブックマークレットとは何ですか？",
    faqWhatA:
      "ブラウザーのブックマークバーにドラッグして使う、小さなブックマークです。どのウェブページでもクリックすると、そのページの URL があらかじめ入力された状態で CitationEasy が新しいタブで開き、コピー＆ペーストなしでワンクリックで整形済みの引用が得られます。",
    faqExtensionNeededQ: "拡張機能をインストールする必要はありますか？",
    faqExtensionNeededA:
      "いいえ。ブックマークレットは単なるブックマークなので、インストールや権限の許可は一切不要です。拡張機能が使えない学校の Chromebook の制限環境や、ほとんどのモバイルブラウザーでも動作します。拡張機能をお好みの場合は、このページから無料の Chrome 拡張機能も利用できます。",
    faqChromeQ: "Chrome 拡張機能はありますか？",
    faqChromeA:
      "はい。無料の CitationEasy Chrome 拡張機能を使うと、現在のタブを引用できるツールバーボタンに加え、開かなくてもリンクや選択した DOI・ISBN を引用できる右クリックメニューが追加されます。訪問したページ上でコードを実行することはなく、必要な権限は activeTab と contextMenus のみです。このページからダウンロードし、chrome://extensions から読み込んでください。Chrome・Edge・Brave など Chromium 系のブラウザーで動作します。",
    faqAddQ: "ブックマークレットはどうやって追加すればよいですか？",
    faqAddA:
      "まずブックマークバーが表示されていることを確認し、このページの「このページを引用」ボタンをそこにドラッグしてください。ドラッグできない場合（モバイルなど）は、新しいブックマークを手動で作成し、ブックマークレットのコードを URL として貼り付けてください。",
    faqSafeQ: "安全ですか？今見ているページの内容を読み取りますか？",
    faqSafeA:
      "はい、安全です。このブックマークレットは、あなたが読んでいるページ上でコードを実行することはありません。そのページの URL を CitationEasy に送るだけで、当サイトのサーバーが公開されているページのメタデータを取得・解析します。これは URL を手動で貼り付けたときとまったく同じ仕組みです。",
    faqOtherSourcesQ: "ウェブサイト以外の資料にも使えますか？",
    faqOtherSourcesA:
      "このブックマークレットはウェブページ用ですが、その裏にあるリンクは `?source=` パラメーターを通じて DOI・ISBN・PMID・arXiv ID も受け付けます。そのため、共有可能な「この資料を引用」リンクは、学術論文や書籍にも使えます。",
    relatedHeading: "関連ツール",
    relatedGenerator: "引用ジェネレーター",
    relatedHowToCite: "ウェブサイトの引用方法",
    relatedTools: "すべてのツール",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "共有された文献リスト－共有された引用の閲覧・取り込み",
    metaDescription:
      "CitationEasyで誰かがあなたに共有した文献リストを開きます。整形済みの引用を閲覧・コピーしたり、リスト全体を自分の文献リストに取り込んだりできます。無料、アカウント不要で、データはリンク自体に保存されます。",
    ogTitle: "共有された文献リスト",
    ogDescription:
      "共有された文献リストを閲覧・取り込みできます。引用はリンクの中に含まれており、サーバーには何も保存されず、リンクの有効期限もありません。",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "パンくずリスト",
    breadcrumbHome: "ホーム",
    breadcrumbCurrent: "共有された文献リスト",
    heading: "共有された文献リスト",
    intro:
      "この引用は他の方があなたと共有したものです。コピーするか、ワンクリックでご自身の CitationEasy の文献リストにリスト全体を取り込むことができます。",
    loading: "共有された文献リストを開いています…",
    copyAll: "すべてコピー",
    copied: "コピーしました",
    copyFailed: "コピーに失敗しました",
    citationOne: "件の引用",
    citationMany: "件の引用",
    addAll: "すべてマイ文献リストに追加",
    added: "{count} 件をあなたの文献リストに追加しました",
    skippedOne: "重複していた {count} 件をスキップしました",
    skippedMany: "重複していた {count} 件をスキップしました",
    openGenerator: "ジェネレーターを開く",
    emptyHeading: "このリンクには共有された文献リストがありません",
    emptyBody:
      "このページは CitationEasy から共有された文献リストを表示するものです。ご自身のリストを共有するには、[引用ジェネレーター](/) でリストを開き、**「書き出し」→「共有リンクをコピー」** を選んで、リンクを好きな相手に送ってください。引用はリンク自体に含まれ、サーバーには何も保存されないため、リンクはいつまでも使い続けられ、データも非公開のままです。",
    decodeError: "この共有リンクを開けませんでした。",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "書籍",
    bookLower: "書籍",
    bookChapter: "書籍の章",
    bookChapterLower: "書籍の章",
    case: "判例",
    caseLower: "判例",
    conferencePaper: "会議論文",
    conferencePaperLower: "会議論文",
    courtCase: "裁判例",
    courtCaseLower: "裁判例",
    federalStatute: "連邦法",
    federalStatuteLower: "連邦法",
    governmentDocument: "政府文書",
    governmentDocumentLower: "政府文書",
    governmentReport: "政府報告書",
    governmentReportLower: "政府報告書",
    journalArticle: "学術論文",
    journalArticleLower: "学術論文",
    lawReviewArticle: "法学雑誌論文",
    lawReviewArticleLower: "法学雑誌論文",
    legislation: "法令",
    legislationLower: "法令",
    newspaperArticle: "新聞記事",
    newspaperArticleLower: "新聞記事",
    patent: "特許",
    patentLower: "特許",
    podcast: "ポッドキャスト",
    podcastLower: "ポッドキャスト",
    preprint: "プレプリント",
    preprintLower: "プレプリント",
    standard: "規格",
    standardLower: "規格",
    thesis: "学位論文",
    thesisLower: "学位論文",
    website: "ウェブサイト",
    websiteLower: "ウェブサイト",
    youtubeVideo: "YouTube動画",
    youtubeVideoLower: "YouTube動画",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "{style} に戻る",
    backToGenerator: "引用ジェネレーターに戻る",
    ctaHeading: "{style} の引用を自動で作成",
    ctaButton: "今すぐ {style} で引用を作成 →",
    faqHeading: "よくある質問",
    resourcesHeading: "その他のリソース",
    relatedHeading: "関連する {style} ガイド",
    resourceGenerator: "無料の引用ジェネレーター（{count} スタイル）",
    resourceTools: "無料のライティングツール",
    resourceGuides: "すべての引用ガイド",
    resourceStyleGenerator: "{style} 引用ジェネレーター",
    resourceExamples: "{style} の引用例",
    resourceFormat: "{style} 書式ガイド",
    resourceInText: "{style} 文中引用ガイド",
    resourceAnnotatedBib: "{style} 注釈付き参考文献リストガイド",
    resourceReferencePage: "{style} {list} ガイド",
    notFoundTitle: "ページが見つかりません",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "{style} の引用例－全資料タイプ対応 [2026]",
    metaDescription:
      "書籍・学術論文・ウェブサイトなど、{style}（{edition}）で整形された引用例を確認できます。そのままコピーできる{list}項目と文中引用付きです。",
    ogTitle: "{style} の引用例",
    ogDescription:
      "よくある資料タイプすべてに対応した、そのままコピーできる {style} の項目です。",
    ogImageTitle: "{style} の引用例",
    ogKind: "{style} {edition}",
    keywordExamples: "{style} 引用例",
    keywordReference: "{style} 参考文献例",
    keywordInText: "{style} 文中引用例",
    keywordList: "{style} {listLower}の例",
    keywordHowTo: "{style} での引用方法",
    breadcrumb: "{style} の引用例",
    heading: "{style} の引用例",
    lead: "よくある資料タイプ {count} 種類について、正しく整形された {style}（{edition}）の引用例を確認できます。各例には、{listLower}の項目と対応する文中引用の両方を掲載しています。",
    entryLabel: "{list}の項目：",
    inTextLabel: "文中引用：",
    ctaBody:
      "手作業での書式整えは不要です。DOI・URL・ISBN を CitationEasy に貼り付けるだけで、数秒で正確に整形された {style} の引用が得られます。",
    faqLookQ: "{style} の引用はどのような形式ですか？",
    faqLookA:
      "{style} の引用は、資料の詳細をすべて記載した{listLower}の項目と、文中引用から構成されます。書式は資料タイプによって異なります。例えば、{style}（{edition}）での書籍の引用には、著者名・発行年・タイトル・出版社が含まれます。",
    faqHowManyQ: "{style} の引用例はいくつ用意されていますか？",
    faqHowManyA:
      "CitationEasyでは、{types} を含む {count} 種類の資料タイプについて、{style} の引用例を提供しています。各例には、{listLower}の項目と対応する文中引用の両方を掲載しています。",
    faqCopyQ: "この {style} の引用例をコピーして使えますか？",
    faqCopyA:
      "はい。このページの {style} の例は、各資料タイプの正確な書式を示しています。ご自身の引用のテンプレートとしてそのままお使いいただけます。自動で整形したい場合は、無料の {style} 引用ジェネレーターをご利用ください。",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle: "{style} 書式ガイド－論文の書式ルール [2026]",
    metaDescription:
      "{style}（{edition}）の論文書式の完全ガイド。正しいフォント・余白・行間・表紙・ヘッダー、そして{listLower}の書式ルールを解説します。",
    ogTitle: "{style} の論文書式",
    ogDescription:
      "{style} 論文の余白・フォント・行間・表紙について解説します。",
    ogImageTitle: "{style} の論文書式",
    ogImageSubtitle: "余白 {margins}・{spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "{style} 書式",
    keywordPaperFormat: "{style} 論文書式",
    keywordRules: "{style} 書式ルール",
    keywordMargins: "{style} 余白 フォント 行間",
    keywordList: "{style} {listLower}の書式",
    breadcrumb: "{style} 書式ガイド",
    heading: "{style} 書式ガイド",
    lead: "文書が必要な基準を満たすよう、この {style}（{edition}）の論文書式ルールに従ってください。このガイドでは、フォント・余白・行間・表紙・ヘッダー、そして{listLower}の書式について解説します。",
    paperHeading: "論文の書式",
    paperIntro:
      "以下は、{style}（{edition}）スタイルで書かれた論文に求められる基本的な書式要件です。",
    labelFont: "フォント",
    labelFontSize: "フォントサイズ",
    labelMargins: "余白",
    labelSpacing: "行間",
    labelTitlePage: "表紙",
    labelHeaders: "ヘッダー・ページ番号",
    listHeading: "{list}の書式",
    listIntro:
      "{style} スタイルで正しく整形するには、{listLower}が次のルールに従っている必要があります。",
    ctaBody:
      "書式の整えは CitationEasy にお任せください。DOI・URL・ISBN を貼り付けるだけで、数秒で正確に整形された {style} の引用が得られます。",
    faqFontQ: "{style} の書式ではどのフォントとサイズを使えばよいですか？",
    faqFontA:
      "{style}（{edition}）では{font}が必要です。標準のフォントサイズは{fontSize}です。",
    faqMarginsQ: "{style} の余白の要件は何ですか？",
    faqMarginsA:
      "{style} の論文では{margins}が必要です。これはすべてのページの上下左右の余白に適用されます。",
    faqTitlePageQ: "{style} では表紙が必要ですか？",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "{style} 文中引用ガイド－ルールと例 [2026]",
    metaDescription:
      "{style}（{edition}）の文中引用の書式を解説します。著者1名、複数著者、直接引用、著者不明、発行年不明の場合のルールを例とともに紹介します。",
    ogTitle: "{style} の文中引用",
    ogDescription: "{style} のすべての文中引用形式を、例とともに紹介します。",
    ogImageTitle: "{style} の文中引用",
    ogImageSubtitle: "著者1名 {singleAuthor}・著者3名以上 {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "{style} 文中引用",
    keywordExamples: "{style} 文中引用例",
    keywordParenthetical: "{style} 括弧内引用",
    keywordRules: "{style} 引用ルール",
    keywordHowTo: "{style} 文中引用の書き方",
    breadcrumb: "{style} の文中引用",
    heading: "{style} の文中引用",
    lead: "この完全ガイドで {style}（{edition}）の文中引用をマスターしましょう。著者1名や複数著者、直接引用、情報が欠けている資料など、あらゆる場面での正しい書式を解説します。",
    rulesHeading: "文中引用のルール",
    rulesIntro:
      "以下は、論文を書く際によく出会う場面ごとの {style} 文中引用ルールです。",
    labelSingleAuthor: "著者1名",
    labelTwoAuthors: "著者2名",
    labelThreeOrMore: "著者3名以上",
    labelDirectQuote: "直接引用",
    labelNoAuthor: "著者不明",
    labelNoDate: "発行年不明",
    examplesHeading: "簡単な例",
    examplesIntro:
      "さまざまな資料タイプにおける、実際の {style} 文中引用の例です。",
    ctaBody:
      "文中引用の書式に悩む必要はありません。DOI・URL・ISBN を CitationEasy に貼り付けるだけで、{listLower}の項目と文中引用がすぐに得られます。",
    faqFormatQ: "{style} の文中引用はどのように書式設定しますか？",
    faqFormatA:
      "{style} で著者が1名の場合は {singleAuthor} の形式を使います。著者2名の場合は {twoAuthors}、著者3名以上の場合は {threeOrMore} を使います。",
    faqQuoteQ: "{style} で直接引用を行うにはどうすればよいですか？",
    faqQuoteA:
      "{style}（{edition}）で直接引用を行う場合は、次の形式を使います：{directQuote}。",
    faqMissingQ: "{style} で著者や発行年が不明な場合はどうすればよいですか？",
    faqMissingA:
      "{style} で著者が不明な場合は {noAuthor} を使います。発行年が不明な場合は {noDate} を使います。",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "{style} の{list}ガイド－書式ルール [2026]",
    metaDescription:
      "{style} の{listLower}（{edition}）の整え方を解説します。{fullName} のためのステップごとの書式ルール、例、よくある間違いを紹介します。",
    ogTitle: "{style} の{listLower}",
    ogDescription: "{style} での{list}の作り方。",
    ogImageTitle: "{style} の{list}",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} の{list}の書式",
    heading: "{style} の{list}の書式",
    lead: "{listLower}は、{style}（{edition}）で書かれた学術論文において、最も重要な要素の一つです。引用したすべての資料の詳細情報を読者に示し、参照元を確認・特定できるようにする役割を持ちます。正しい書式は、学術的な信頼性を保つために欠かせません。このガイドでは、具体的なルールと実際の例を紹介し、学生がよく犯す間違いを解説します。",
    rulesHeading: "書式のルール",
    rulesIntro:
      "{style} の{listLower}を作成する際は、以下のルールに従ってください。",
    exampleHeading: "{list}の例",
    exampleIntro:
      "さまざまな資料タイプの項目を含む、{style} の{listLower}の例です。",
    mistakesHeading: "避けるべきよくある間違い",
    mistakesIntro:
      "学生が {style} の{listLower}を作成する際によく犯す、5 つの書式の間違いを紹介します。",
    mistakeIndent:
      "**ぶら下げインデントの欠落や誤り：** 各項目は1行目を左端に揃え、2行目以降を 0.5 インチ（約 1.27cm）字下げする必要があります。Tab キーを押すのではなく、ワープロソフトの段落設定を使いましょう。",
    mistakeOrder:
      "**アルファベット順や並び順の誤り：** 項目は {style} のルールに従って並べる必要があります。アルファベット順に並べる際は「A」「An」「The」などの冠詞は無視します。番号方式のスタイルでは、本文中に最初に登場した順に項目を並べます。",
    mistakeSpacing:
      "**行間の不統一：** {listLower}全体を通して、行間が統一されているか確認しましょう。シングルスペースとダブルスペースが混在するのはよくある間違いで、見落としがちです。",
    mistakeItalics:
      "**斜体の誤用：** 書籍や雑誌など、単独で発行される作品のタイトルは斜体にしますが、論文や章のタイトルは斜体にしません。どの要素を斜体にすべきかは、{style} のガイドラインで正確に確認してください。",
    mistakeLinks:
      "**DOI や URL の欠落・リンク切れ：** DOI が利用可能な場合は、必ずクリック可能なリンクとして記載してください。論文を提出する前に、すべての URL が正しい資料につながることを確認しましょう。",
    ctaHeading: "{list}を自動で作成",
    ctaBody:
      "手作業での書式整えは不要です。DOI・URL・ISBN を CitationEasy に貼り付けるだけで、数秒で正確に整形された {style} の引用が得られ、そのまま{listLower}に使えます。",
    faqWhatQ: "{style} の{list}とは何ですか？",
    faqWhatA:
      "{style} の{list}は、論文の末尾にあるセクションで、本文中で引用したすべての資料を、{fullName}（{edition}）のガイドラインに従って一覧にしたものです。読者が参照元を特定・確認できるようにする役割があります。",
    faqFormatQ: "{style} の{listLower}はどのように整形すればよいですか？",
    faqFormatA:
      "新しいページから始め、タイトルを「{list}」とし、論文中で引用したすべての資料を一覧にしてください。ぶら下げインデント・行間・アルファベット順や番号の並び順・斜体について、{style} 固有のルールに従いましょう。",
    faqDifferenceQ: "{listLower}と文献目録の違いは何ですか？",
    faqDifferenceA:
      "{listLower}には、論文中で直接引用した資料のみが含まれますが、文献目録には、参照はしたが引用はしなかった資料も含まれることがあります。{style}（{edition}）では、論文末尾の一覧を「{list}」と呼びます。",
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "{style} 注釈付き参考文献リストガイドと例 [2026]",
    metaDescription:
      "{style}（{edition}）で注釈付き参考文献リストを作成する方法を解説します。{fullName} の注釈付き参考文献リストのための書式ルール、記載例、コツを紹介します。",
    ogTitle: "{style} の注釈付き参考文献リスト",
    ogDescription: "{style} での注釈付き参考文献リストの整え方。",
    ogImageTitle: "{style} の注釈付き参考文献リスト",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} の注釈付き参考文献リスト",
    heading: "{style} の注釈付き参考文献リスト",
    lead: "注釈付き参考文献リストとは、それぞれの引用文献に短い説明的または評価的な段落を付け加えた資料一覧です。{style} 形式（{edition}）では、各項目はまず正しく整形された文献情報から始まり、続けてその資料を要約・評価・考察する注釈が付きます。このガイドでは、洗練された {style} の注釈付き参考文献リストを作成するために必要なルール・書式・例を順を追って解説します。",
    whatHeading: "注釈付き参考文献リストとは？",
    whatBody:
      "注釈付き参考文献リストは、通常の{listLower}に、各引用の後に短い段落を追加したものです。この注釈により、読者はその資料の内容・質・関連性を把握できます。教員は、学生が資料を批判的に評価し、各資料が研究テーマにどう貢献するかを示す力を養うために、注釈付き参考文献リストの課題をよく出します。",
    whatTypes:
      "注釈には主に3つの種類があります。資料の内容を要約する**記述的**注釈、資料の質や信頼性を評価する**評価的**注釈、そしてその両方を行う**組み合わせ**注釈です。課題の指示で、どの種類を使うべきか指定されているはずです。",
    rulesHeading: "{style} 注釈付き参考文献リストのルール",
    rulesIntro:
      "{fullName} で注釈付き参考文献リストを整形する際は、以下のルールに従ってください。",
    exampleHeading: "注釈付き参考文献リストの記載例",
    exampleIntro:
      "以下は、{sourceType}についての {style} の注釈付き参考文献リストの記載例です。",
    exampleAnnotation:
      "この資料は、実証的な根拠に裏付けられた説得力のある主張を提示しながら、テーマについて包括的な概観を提供している。著者は、幅広い一次資料・二次資料を活用し、説得力のある論を組み立てている。研究手法は厳密であり、結果も明確に示されているため、このテーマを理解するうえで貴重な資料となっている。この資料は、特に研究プロジェクトの理論的枠組みを構築するのに有用であり、参考文献リスト内の他の資料を補完する視点を提供している。",
    tipsHeading: "{style} の注釈を書くコツ",
    tipSummarize:
      "まず資料を2〜3文で要約し、その後にその長所・限界・関連性についてのあなた自身の評価を加えましょう。",
    tipTone:
      "注釈全体を通して三人称と学術的な文体を使いましょう。教員から求められない限り、くだけた表現や一人称での感想は避けてください。",
    tipLength:
      "各注釈は100〜200語程度に収めましょう。簡潔に、資料の最も重要な点に焦点を当ててください。",
    tipRelevance:
      "その資料が全体の研究にどう位置づけられるかを説明しましょう。どのような独自の視点や根拠をもたらすかを記述してください。",
    tipCitation:
      "注釈を書く前に、各項目の引用部分が {fullName} の書式ルールに正確に従っているか確認しましょう。",
    ctaHeading: "注釈付き参考文献リストを自動で作成",
    ctaBody:
      "CitationEasyの注釈付き参考文献リスト作成ツールを使って、正しく整形された {style} の引用を作成し、そこに注釈を追加しましょう。",
    ctaButton: "注釈付き参考文献リスト作成ツールを開く →",
    faqWhatQ: "{style} における注釈付き参考文献リストとは何ですか？",
    faqWhatA:
      "{style}（{edition}）における注釈付き参考文献リストとは、{fullName} 形式で整形された引用のリストで、各引用の後に、その資料を要約・評価・考察する短い段落が続くものです。読者が各資料の関連性や質を理解する助けとなります。",
    faqLengthQ: "注釈はどのくらいの長さにすればよいですか？",
    faqLengthA:
      "注釈は一般的に100〜200語程度です。求められる分析の深さによっては、より短い、あるいはより長い注釈が必要な課題もあります。具体的な文字数の指定については、必ず教員のガイドラインを確認してください。",
    faqIncludeQ: "注釈には何を含めるべきですか？",
    faqIncludeA:
      "注釈には、資料の主な主張や結論の簡潔な要約、資料の信頼性や有用性についての評価、そしてその資料が自分の研究にどう位置づけられるかについての考察を含めるべきです。純粋に記述的な注釈もあれば、批判的な分析を含む注釈もあります。",
  },

  guidePage: {
    byline: "執筆: {author}",
    published: "{date} 公開",
    updated: "{date} 更新",
    readingTime: "other:読了目安 {count} 分",
    wordCount: "other:{count} 語",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "ガイドライブラリ",
    browseByCategory: "カテゴリから探す",
    recentlyUpdated: "最近更新されたガイド",
    allGuides: "すべてのガイド",
    guideCount: "other:{count}件のガイド",
    updatedOn: "{date} 更新",
    minRead: "other:読了目安 {count}分",
    onThisPage: "このページの内容",
    viewAllInCategory: "{category}のガイドをすべて見る",
    moreInCategory: "{category}のその他のガイド",
    aboutThisGuide: "このガイドについて",
    provenance: "執筆: {author}。{published} 公開、最終更新 {updated}。",
    categoryIntroSuffix:
      "すべてのガイドは無料で、学生と研究者向けに書かれ、最終確認日がわかるよう日付が付いています。",
    photoCredit: "写真: {author}、{source}（{license}）",
    imageAlt: "{category}のガイドを表す写真",
    imageSourceCommons: "ウィキメディア・コモンズ",
    apaStyleName: "APAスタイル",
    apaStyleDescription:
      "APA第7版でウェブサイト、学術誌論文、書籍、動画などを引用する方法。参考文献リストと本文中引用の例付き。",
    mlaStyleName: "MLAスタイル",
    mlaStyleDescription:
      "MLA第9版でウェブページや論文から詩、戯曲、映画、授業資料まで、あらゆる一般的な資料を引用する方法。",
    chicagoStyleName: "シカゴスタイル",
    chicagoStyleDescription:
      "書籍、論文、アーカイブ、政府文書、メディアの注・参考文献方式と著者・年方式を扱うシカゴマニュアルのガイド。",
    styleComparisonsName: "スタイル比較",
    styleComparisonsDescription:
      "APA、MLA、シカゴ、ハーバード、バンクーバー、IEEEなどを並べて比較し、分野ごとに求められるスタイルを解説。",
    researchMethodsName: "研究方法",
    researchMethodsDescription:
      "研究論文の計画、文献レビュー、ノートの取り方、資料の評価、剽窃の回避、参考文献リストの作成。",
    academicWritingName: "アカデミックライティング",
    academicWritingDescription:
      "要旨、序論、結論、論文の主張、方法論の章、明快な学術文章のための執筆ガイド。",
    fieldSpecificName: "分野別",
    fieldSpecificDescription:
      "心理学、歴史学、文学から医学、工学、法学、看護学まで、分野ごとの引用ガイド。",
    sourceEvaluationName: "資料の評価",
    sourceEvaluationDescription:
      "信頼性の判断、学術資料と一般資料の見分け方、Google Scholarや図書館データベースの使い方、バイアスの見抜き方。",
    citationHelpName: "引用のヘルプ",
    citationHelpDescription:
      "難しいケースへの答え：著者や日付がない資料、複数著者、PDF、AIツール、判例、引用のインポートとエクスポート。",
  },

  common: {
    backToGuides: "← ガイド一覧に戻る",
    free: "無料",
    noSignup: "登録不要",
    backToHome: "引用ジェネレーターに戻る",
    inEnglish: "英語版",
    viewInEnglish: "英語で見る",
    availableInEnglish: "このページは英語版でより詳しくご覧いただけます。",
    otherLanguages: "他の言語",
    skipToContent: "本文へスキップ",
    cookieNotice:
      "CitationEasy を無料で提供するため、分析と広告に Cookie を使用しています。",
    privacyPolicy: "プライバシーポリシー",
    accept: "同意する",
    decline: "拒否する",
    advertisement: "広告",
  },
  legalPage: {
    backLink: "← ジェネレーターに戻る",
    effective: "発効日：",
    updated: "最終更新日：",
  },
};

export default ja;
